var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _g2, _g3, _g4, _g5, _g6, _g7, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _g8, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _g9, _g0, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _g1, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _g10, _rect, _rect2, _g11, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _g12, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _g13, _path245, _path246;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehicle2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 182.668,
    height: 83.36,
    viewBox: "0 0 182.668 83.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_753",
    "data-name": "Group 753",
    transform: "translate(-49.297 -2523.14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_745",
    "data-name": "Group 745",
    transform: "translate(49.297 2523.14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_674",
    "data-name": "Group 674",
    transform: "translate(99.751 21.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_659",
    "data-name": "Group 659",
    transform: "translate(20.788 7.202)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13085",
    "data-name": "Path 13085",
    d: "M270.011,245.3l19.57,22.015-2.61,3.328-17.713-20.953Z",
    transform: "translate(-269.259 -245.299)",
    fill: "#a3a3a3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13086",
    "data-name": "Path 13086",
    d: "M269.9,245.874l19.323,21.969-.491.622L269.662,247.23Z",
    transform: "translate(-269.227 -245.402)",
    fill: "#a3a3a3",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13087",
    "data-name": "Path 13087",
    d: "M270.952,248.161l18.935,22.025-1.222.971L270.952,250.2Z",
    transform: "translate(-270.952 -245.814)",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13088",
    "data-name": "Path 13088",
    d: "M292.971,249.95l-4.132-4.651-.752,4.39,3,3.55Q291.99,251.57,292.971,249.95Z",
    transform: "translate(-288.087 -245.299)",
    fill: "#707070",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13089",
    "data-name": "Path 13089",
    d: "M269.259,272.055l2.42,2.87,2.61-3.328-2.22-2.505A37.968,37.968,0,0,0,269.259,272.055Z",
    transform: "translate(-253.966 -249.582)",
    fill: "#707070",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13090",
    "data-name": "Path 13090",
    d: "M286.619,248.913l9.013-8.471a2.831,2.831,0,0,1,1.245-.688c1.062-.069,2.266.742,1.539,3.039l-6.178,13.891Z",
    transform: "translate(-271.762 -237.098)",
    fill: "#F26A1B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13091",
    "data-name": "Path 13091",
    d: "M295.074,247.527l-2.959,2.786,5.619,7.771,1.893-4.24C298.108,251.743,296.6,249.633,295.074,247.527Z",
    transform: "translate(-277.258 -238.498)",
    fill: "#F26A1B",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13092",
    "data-name": "Path 13092",
    d: "M272.432,238.678l31.315,38.553-3.073,6.933-31.415-38.846Z",
    transform: "translate(-262.636 -236.905)",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13093",
    "data-name": "Path 13093",
    d: "M273.222,279.011a63.734,63.734,0,0,1-3.963,5.81l5.35,6.6,3.073-6.934Z",
    transform: "translate(-236.57 -244.166)",
    fill: "#F26A1B",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13094",
    "data-name": "Path 13094",
    d: "M272.354,242.45l31.319,38.555-1.393,3.135-30.908-38.8Z",
    transform: "translate(-264.295 -237.584)",
    fill: "#707070",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13095",
    "data-name": "Path 13095",
    d: "M269.622,240.986l31.315,38.568-.524,1.176-31.153-38.951Z",
    transform: "translate(-259.825 -237.321)",
    fill: "#a3a3a3",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13096",
    "data-name": "Path 13096",
    d: "M310.036,241.957l-2.668-3.279-3.173,6.64,1.515,1.88C307.212,245.514,308.583,243.68,310.036,241.957Z",
    transform: "translate(-297.571 -236.905)",
    fill: "#F26A1B",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13097",
    "data-name": "Path 13097",
    d: "M229.707,262.457l-2.357,3.245,1.181.887s-9.429,13.337-10.179,18.191,4.272,17.851,4.272,17.851H266.2V301.6h-2.809l-26.441-29.53s-2.663-2.617-1.766-4.888,1.572-4.728,1.572-4.728Z",
    transform: "translate(-183.28 -241.186)",
    fill: "#4A4A4A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13098",
    "data-name": "Path 13098",
    d: "M272.7,268.987l-3.246-1.373s-.591-.3-1.628.685-3.892,4.7-3.892,4.7-1.073,1.314-.387,2.3a40.268,40.268,0,0,1,2.138,4.5Z",
    transform: "translate(-226.712 -242.106)",
    fill: "#e87221"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13099",
    "data-name": "Path 13099",
    d: "M269.285,268.073c-1.269,1.722-5.181,7.685-5.97,8.8.723,1.4,1.333,3.012,1.333,3.012l7.015-10.8Z",
    transform: "translate(-225.678 -242.197)",
    fill: "#e87221",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13100",
    "data-name": "Path 13100",
    d: "M303.668,237.006l11.57-.49s1.326.444,1.326,1.622-6.084,8.9-6.084,8.9Z",
    transform: "translate(-303.668 -236.516)",
    fill: "#4A4A4A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13101",
    "data-name": "Path 13101",
    d: "M316.826,240.625a5.786,5.786,0,0,0-1.538-2.76,5.165,5.165,0,0,0-1.556-.926l-3.309.143,6.812,10.034s.186-.231.484-.622C318,246.121,317.217,241.942,316.826,240.625Z",
    transform: "translate(-310.424 -236.592)",
    fill: "#4A4A4A",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_660",
    "data-name": "Group 660",
    transform: "translate(34.995 21.271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13102",
    "data-name": "Path 13102",
    d: "M252.939,301.6H250.13l-26.441-29.53s-2.663-2.617-1.766-4.888,1.572-4.728,1.572-4.728h-3.005l-1.722,3.937s-1.476,4.042.686,6.307c1.758,1.824,20.505,22.2,27.62,29.93h5.866Z",
    transform: "translate(-205.017 -262.457)",
    fill: "#e87221"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13103",
    "data-name": "Path 13103",
    d: "M239.179,266.394l1.722-3.937h-4.04L234.5,265.7l1.181.887s-9.429,13.337-10.179,18.191,4.272,17.851,4.272,17.851h37.707c-7.115-7.731-25.862-28.105-27.62-29.93C237.7,270.436,239.179,266.394,239.179,266.394Z",
    transform: "translate(-225.429 -262.457)",
    fill: "#4A4A4A"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_661",
    "data-name": "Group 661",
    transform: "translate(7.685 2.411)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13104",
    "data-name": "Path 13104",
    d: "M309.527,240.587a1.13,1.13,0,1,1-1.127-1.131A1.125,1.125,0,0,1,309.527,240.587Z",
    transform: "translate(-307.267 -239.456)",
    fill: "#e87221"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13105",
    "data-name": "Path 13105",
    d: "M309.12,240.672a.615.615,0,1,1-.615-.614A.612.612,0,0,1,309.12,240.672Z",
    transform: "translate(-307.372 -239.564)",
    fill: "#e87221",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    "data-name": "Group 662",
    transform: "translate(20.543 9.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13106",
    "data-name": "Path 13106",
    d: "M293.848,249.1a1.126,1.126,0,1,1-1.124-1.128A1.125,1.125,0,0,1,293.848,249.1Z",
    transform: "translate(-291.596 -247.975)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13107",
    "data-name": "Path 13107",
    d: "M293.454,249.2a.618.618,0,1,1-.614-.617A.616.616,0,0,1,293.454,249.2Z",
    transform: "translate(-291.712 -248.084)",
    fill: "#F26A1B"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_663",
    "data-name": "Group 663",
    transform: "translate(38.592 29.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13108",
    "data-name": "Path 13108",
    d: "M271.834,273.936a1.132,1.132,0,1,1-1.132-1.128A1.133,1.133,0,0,1,271.834,273.936Z",
    transform: "translate(-269.571 -272.808)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13109",
    "data-name": "Path 13109",
    d: "M271.429,274.024a.616.616,0,0,1-1.232,0,.616.616,0,0,1,1.232,0Z",
    transform: "translate(-269.68 -272.916)",
    fill: "#F26A1B"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_664",
    "data-name": "Group 664",
    transform: "translate(33.868 39.983)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13110",
    "data-name": "Path 13110",
    d: "M277.772,286a.729.729,0,0,1-1.458,0,.729.729,0,0,1,1.458,0Z",
    transform: "translate(-276.314 -285.276)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13111",
    "data-name": "Path 13111",
    d: "M277.511,286.059a.4.4,0,0,1-.4.4.391.391,0,0,1-.392-.4.387.387,0,0,1,.392-.394A.394.394,0,0,1,277.511,286.059Z",
    transform: "translate(-276.386 -285.346)",
    fill: "#F26A1B"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_665",
    "data-name": "Group 665",
    transform: "translate(35.874 36.585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13112",
    "data-name": "Path 13112",
    d: "M275.327,281.858a.726.726,0,1,1-.726-.726A.722.722,0,0,1,275.327,281.858Z",
    transform: "translate(-273.875 -281.132)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13113",
    "data-name": "Path 13113",
    d: "M275.069,281.914a.405.405,0,0,1-.4.4.4.4,0,0,1-.4-.4.388.388,0,0,1,.4-.391A.392.392,0,0,1,275.069,281.914Z",
    transform: "translate(-273.94 -281.202)",
    fill: "#F26A1B"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_666",
    "data-name": "Group 666",
    transform: "translate(8.709 9.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13114",
    "data-name": "Path 13114",
    d: "M308.456,248.443a.725.725,0,1,1-.726-.727A.728.728,0,0,1,308.456,248.443Z",
    transform: "translate(-307.006 -247.716)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13115",
    "data-name": "Path 13115",
    d: "M308.206,248.5a.393.393,0,0,1-.394.4.4.4,0,1,1,0-.791A.391.391,0,0,1,308.206,248.5Z",
    transform: "translate(-307.088 -247.786)",
    fill: "#F26A1B"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_667",
    "data-name": "Group 667",
    transform: "translate(10.974 6.213)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13116",
    "data-name": "Path 13116",
    d: "M305.693,244.824a.727.727,0,1,1-.722-.731A.725.725,0,0,1,305.693,244.824Z",
    transform: "translate(-304.238 -244.093)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13117",
    "data-name": "Path 13117",
    d: "M305.429,244.883a.4.4,0,0,1-.4.394.394.394,0,1,1,.4-.394Z",
    transform: "translate(-304.302 -244.164)",
    fill: "#F26A1B"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13118",
    "data-name": "Path 13118",
    d: "M231.546,290.556c.9,4.029,3.072,11.365,3.072,11.365H265.69l-4.846-4.636-2.444,1.554-2.284-2.654,1.255-1.961-4.908-5.518-2.4,1.047-3.027-3.328,1.915-1.766-5.606-5.689-1.579,2.011-2.954-3.012,1.08-2.128-1.676-1.657S230.069,284.006,231.546,290.556Z",
    transform: "translate(-193.508 -243.297)",
    fill: "#e87221"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13119",
    "data-name": "Path 13119",
    d: "M231.553,290.751c.91,4.029,3.221,11.365,3.221,11.365h30.369l-4.351-4.161-2.627,1.516-2.6-3.091,1.255-1.961-4.384-4.928-2.458,1.024-3.5-3.894,1.5-1.2-4.883-5.2-1.495,1.32-3.346-3.368.886-1.746-1.458-1.149S230.094,284.2,231.553,290.751Z",
    transform: "translate(-192.961 -243.492)",
    fill: "#4A4A4A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13120",
    "data-name": "Path 13120",
    d: "M287.74,246.215l5.322-4.9s1.1-1.624,2.318-.886l-6.36,7.583Z",
    transform: "translate(-269.423 -237.187)",
    fill: "#F26A1B",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13121",
    "data-name": "Path 13121",
    d: "M291.907,241.556a4.731,4.731,0,0,1-.485,2.216c-.6,1.574-3.672,8.325-3.672,8.325l-.614-.736Z",
    transform: "translate(-265.466 -237.423)",
    fill: "#F26A1B",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_668",
    "data-name": "Group 668",
    transform: "translate(50.142 22.819)"
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13122",
    "data-name": "Path 13122",
    d: "M257.872,265.194a.849.849,0,1,1-.848-.849A.848.848,0,0,1,257.872,265.194Z",
    transform: "translate(-256.174 -264.345)",
    fill: "#4A4A4A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13123",
    "data-name": "Path 13123",
    d: "M257.566,265.263a.46.46,0,1,1-.46-.468A.461.461,0,0,1,257.566,265.263Z",
    transform: "translate(-256.256 -264.426)",
    fill: "#e87221",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_669",
    "data-name": "Group 669",
    transform: "translate(51.453 30.933)"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13124",
    "data-name": "Path 13124",
    d: "M256.275,275.085a.848.848,0,1,1-.841-.845A.847.847,0,0,1,256.275,275.085Z",
    transform: "translate(-254.579 -274.24)",
    fill: "#4A4A4A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13125",
    "data-name": "Path 13125",
    d: "M255.971,275.147a.462.462,0,1,1-.458-.459A.464.464,0,0,1,255.971,275.147Z",
    transform: "translate(-254.658 -274.321)",
    fill: "#e87221",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_670",
    "data-name": "Group 670",
    transform: "translate(57.345 37.664)"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13126",
    "data-name": "Path 13126",
    d: "M249.089,283.3a.848.848,0,0,1-1.7,0,.848.848,0,1,1,1.7,0Z",
    transform: "translate(-247.393 -282.448)",
    fill: "#4A4A4A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13127",
    "data-name": "Path 13127",
    d: "M248.785,283.366a.462.462,0,1,1-.458-.458A.462.462,0,0,1,248.785,283.366Z",
    transform: "translate(-247.473 -282.531)",
    fill: "#e87221",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_671",
    "data-name": "Group 671",
    transform: "translate(63.889 44.698)"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13128",
    "data-name": "Path 13128",
    d: "M241.109,291.874a.848.848,0,1,1-.845-.848A.847.847,0,0,1,241.109,291.874Z",
    transform: "translate(-239.413 -291.026)",
    fill: "#4A4A4A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13129",
    "data-name": "Path 13129",
    d: "M240.808,291.94a.465.465,0,1,1-.465-.463A.466.466,0,0,1,240.808,291.94Z",
    transform: "translate(-239.492 -291.107)",
    fill: "#e87221",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_672",
    "data-name": "Group 672",
    transform: "translate(70.02 51.493)"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13130",
    "data-name": "Path 13130",
    d: "M233.63,300.162a.852.852,0,1,1-.849-.849A.849.849,0,0,1,233.63,300.162Z",
    transform: "translate(-231.927 -299.313)",
    fill: "#4A4A4A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13131",
    "data-name": "Path 13131",
    d: "M233.323,300.231a.462.462,0,1,1-.462-.47A.465.465,0,0,1,233.323,300.231Z",
    transform: "translate(-232.007 -299.394)",
    fill: "#e87221",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    "data-name": "Group 673",
    transform: "translate(76.531 58.624)"
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13132",
    "data-name": "Path 13132",
    d: "M225.69,308.858a.849.849,0,1,1-.854-.848A.848.848,0,0,1,225.69,308.858Z",
    transform: "translate(-223.992 -308.01)",
    fill: "#4A4A4A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13133",
    "data-name": "Path 13133",
    d: "M225.392,308.926a.465.465,0,1,1-.467-.467A.463.463,0,0,1,225.392,308.926Z",
    transform: "translate(-224.08 -308.091)",
    fill: "#e87221",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13134",
    "data-name": "Path 13134",
    d: "M269.021,266.461l-9.08,14.7a13.145,13.145,0,0,0-1.107,8.639l2.614,9.045s-3.42-11.611-.776-17.259c2.375-5.072,12.23-18.827,12.23-18.827h-3.141l-2,2.593Z",
    transform: "translate(-223.036 -241.241)",
    fill: "#4A4A4A",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_694",
    "data-name": "Group 694",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_676",
    "data-name": "Group 676",
    transform: "translate(23.88)"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13135",
    "data-name": "Path 13135",
    d: "M410.141,233.636h-2.185V215.584a1.717,1.717,0,0,0-1.246-1.653c-2.072-.477-4.656-1.141-4.681-1.15l.549-2.112c.021.007,2.581.664,4.622,1.143a3.891,3.891,0,0,1,2.941,3.772Z",
    transform: "translate(-402.029 -210.669)",
    fill: "#F26A1B"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_675",
    "data-name": "Group 675",
    transform: "translate(0.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13136",
    "data-name": "Path 13136",
    d: "M406.8,211.812c-2.042-.479-4.6-1.137-4.622-1.143l-.147.561,4.808,1.155s2.169.589,2.318,3.678v15.687l-1.6.373v1.512h2.185V215.584A3.891,3.891,0,0,0,406.8,211.812Z",
    transform: "translate(-402.029 -210.669)",
    fill: "#F26A1B"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13137",
    "data-name": "Path 13137",
    d: "M404.681,239.121V235.9l-11.409,1.429v3.451Z",
    transform: "translate(-389.389 -215.211)",
    fill: "#F26A1B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13138",
    "data-name": "Path 13138",
    d: "M404.681,240.787v-3.233l-11.409,1.437v3.451Z",
    transform: "translate(-389.389 -215.509)",
    fill: "#F26A1B",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13139",
    "data-name": "Path 13139",
    d: "M403.761,215.982v16.725h.448l-.09-15.174Z",
    transform: "translate(-397.517 -211.625)",
    fill: "#949494",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13140",
    "data-name": "Path 13140",
    d: "M426.585,236.516s-34.575,3.1-43.134,6.65c0,0-1.48.664-2.667,3.874s-5.607,21.23-5.607,21.23H421.41Z",
    transform: "translate(-372.574 -215.322)",
    fill: "#4A4A4A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_677",
    "data-name": "Group 677",
    transform: "translate(2.603 21.194)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13141",
    "data-name": "Path 13141",
    d: "M387.829,257.2c4.763-2.451,10.4-4.243,15.8-3.317,5.774,1.009,10.617,4.653,14.24,9.146a36.28,36.28,0,0,1,3.072,3.987c.188.317.362.646.518.979l5.128-31.477s-1.346.122-3.553.335l-4.67,20.936s-4.237-8.175-21.185-6.893a25.1,25.1,0,0,0-21.1,13.768c-.538,2.158-.895,3.608-.895,3.608h1.867C378.946,263.284,383.167,259.593,387.829,257.2Z",
    transform: "translate(-375.177 -236.516)",
    fill: "#ca7123"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13142",
    "data-name": "Path 13142",
    d: "M421.462,241.039,401.8,243.512s-6.635,1-7.872,3.236-2.459,8.721-2.459,8.721l4.144.133s3.1-4.883,5.257-5.055,19.745-.946,19.745-.946.764.232,1.386-1.075a45.819,45.819,0,0,0,1.543-5.872A1.607,1.607,0,0,0,421.462,241.039Z",
    transform: "translate(-382.899 -216.125)",
    fill: "#F26A1B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13143",
    "data-name": "Path 13143",
    d: "M420.207,241.933l-18.892,2.337s-6.266.642-7.6,3.5a52.619,52.619,0,0,0-2.242,7.855l3.252.133s3.1-4.883,5.257-5.055,19.745-.946,19.745-.946.764.232,1.386-1.075a45.826,45.826,0,0,0,1.543-5.872S422.278,241.491,420.207,241.933Z",
    transform: "translate(-382.007 -216.281)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_678",
    "data-name": "Group 678",
    transform: "translate(9.465 25.562)"
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13144",
    "data-name": "Path 13144",
    d: "M392.556,249.754c.2-.3.388-.6.584-.893-.075-.111-.143-.211-.207-.322-.143.465-.273.881-.4,1.178C392.542,249.729,392.556,249.743,392.556,249.754Z",
    transform: "translate(-362.824 -243.048)",
    fill: "none"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13145",
    "data-name": "Path 13145",
    d: "M428.869,256.019c.057-.233.116-.482.18-.737-.112.169-.219.342-.33.508C428.771,255.875,428.823,255.946,428.869,256.019Z",
    transform: "translate(-428.407 -244.262)",
    fill: "none"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13146",
    "data-name": "Path 13146",
    d: "M393.817,251.2c.013.026.039.052.052.077.076-.116.156-.23.228-.348A1.672,1.672,0,0,1,393.817,251.2Z",
    transform: "translate(-364.837 -243.477)",
    fill: "none"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13147",
    "data-name": "Path 13147",
    d: "M418.534,252.771c.039-.06.079-.116.117-.175a1.918,1.918,0,0,1-.221.015C418.469,252.667,418.5,252.721,418.534,252.771Z",
    transform: "translate(-409.573 -243.778)",
    fill: "none"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13148",
    "data-name": "Path 13148",
    d: "M420.056,245.291c.153-.037.3-.077.453-.112-.066-.1-.129-.2-.194-.3C420.223,245.009,420.139,245.154,420.056,245.291Z",
    transform: "translate(-412.764 -242.39)",
    fill: "none"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13149",
    "data-name": "Path 13149",
    d: "M427.192,250.307c.043-.107.08-.214.117-.317-.05.086-.108.17-.162.255C427.16,250.261,427.179,250.291,427.192,250.307Z",
    transform: "translate(-425.38 -243.309)",
    fill: "none"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13150",
    "data-name": "Path 13150",
    d: "M421.628,245.852c.31-.115.622-.223.925-.32-.123-.184-.241-.369-.364-.553C422.005,245.272,421.821,245.561,421.628,245.852Z",
    transform: "translate(-416.097 -242.407)",
    fill: "none"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13151",
    "data-name": "Path 13151",
    d: "M391.905,244.8c-.025-.048-.063-.1-.09-.144-.037.143-.066.289-.1.442C391.778,245.005,391.842,244.9,391.905,244.8Z",
    transform: "translate(-360.919 -242.349)",
    fill: "none"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13152",
    "data-name": "Path 13152",
    d: "M391.932,248.242c.182-.283.364-.567.544-.841-.176-.266-.351-.53-.516-.8-.1.406-.208.815-.312,1.2C391.737,247.951,391.836,248.1,391.932,248.242Z",
    transform: "translate(-361.436 -242.7)",
    fill: "none"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13153",
    "data-name": "Path 13153",
    d: "M413.013,252.653c.079-.112.151-.23.221-.348-.143,0-.283.011-.426.018C412.872,252.436,412.951,252.544,413.013,252.653Z",
    transform: "translate(-399.546 -243.726)",
    fill: "none"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13154",
    "data-name": "Path 13154",
    d: "M416.613,252.657c.034-.055.075-.109.112-.163-.078,0-.142.007-.207.007C416.552,252.555,416.584,252.6,416.613,252.657Z",
    transform: "translate(-406.081 -243.76)",
    fill: "none"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13155",
    "data-name": "Path 13155",
    d: "M414.814,252.586a1.593,1.593,0,0,0,.123-.184c-.076,0-.153,0-.232.007C414.746,252.472,414.784,252.532,414.814,252.586Z",
    transform: "translate(-402.804 -243.743)",
    fill: "none"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13156",
    "data-name": "Path 13156",
    d: "M408.474,243.678l.142-.018c-.02-.032-.046-.064-.066-.1C408.525,243.6,408.5,243.64,408.474,243.678Z",
    transform: "translate(-391.374 -242.152)",
    fill: "none"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13157",
    "data-name": "Path 13157",
    d: "M411.922,244.092l.533-.064c-.08-.123-.164-.252-.248-.376C412.117,243.792,412.019,243.945,411.922,244.092Z",
    transform: "translate(-398.04 -242.168)",
    fill: "none"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13158",
    "data-name": "Path 13158",
    d: "M410.219,243.891l.284-.039c-.037-.066-.089-.136-.129-.2C410.323,243.731,410.268,243.817,410.219,243.891Z",
    transform: "translate(-394.692 -242.168)",
    fill: "none"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13159",
    "data-name": "Path 13159",
    d: "M398.555,242.459l.047-.008c-.009-.012-.02-.024-.02-.03A.091.091,0,0,0,398.555,242.459Z",
    transform: "translate(-373.226 -241.947)",
    fill: "none"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13160",
    "data-name": "Path 13160",
    d: "M390.8,245.977c.194.3.39.592.575.89.178-.277.358-.543.526-.808-.194-.3-.383-.594-.569-.9C391.145,245.434,390.98,245.695,390.8,245.977Z",
    transform: "translate(-360.159 -242.44)",
    fill: "none"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13161",
    "data-name": "Path 13161",
    d: "M416.865,250.075c.171.268.349.546.524.814.188-.3.382-.6.579-.9-.175-.273-.352-.546-.531-.814C417.247,249.478,417.061,249.771,416.865,250.075Z",
    transform: "translate(-407.606 -243.163)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13162",
    "data-name": "Path 13162",
    d: "M396.243,251.435q.546-.023.933-.044c-.143-.229-.3-.462-.447-.7C396.567,250.939,396.413,251.187,396.243,251.435Z",
    transform: "translate(-369.905 -243.436)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13163",
    "data-name": "Path 13163",
    d: "M394.475,251.357c.3-.022.467-.027.467-.027a.723.723,0,0,0,.467-.05c-.143-.23-.3-.453-.44-.687C394.8,250.843,394.643,251.1,394.475,251.357Z",
    transform: "translate(-366.687 -243.418)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13164",
    "data-name": "Path 13164",
    d: "M397.95,251.492c.381-.017.745-.032,1.08-.044-.18-.273-.349-.546-.53-.819C398.317,250.918,398.139,251.207,397.95,251.492Z",
    transform: "translate(-373.158 -243.424)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13165",
    "data-name": "Path 13165",
    d: "M392.783,248.737c.18.291.361.576.544.855.129-.3.258-.713.4-1.178-.132-.188-.248-.384-.371-.568C393.172,248.144,392.975,248.44,392.783,248.737Z",
    transform: "translate(-363.62 -242.923)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13166",
    "data-name": "Path 13166",
    d: "M399.742,251.5a.516.516,0,0,0,.046.064c.347-.02.684-.032,1.013-.048-.176-.276-.356-.554-.536-.827C400.1,250.959,399.915,251.231,399.742,251.5Z",
    transform: "translate(-376.399 -243.436)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13167",
    "data-name": "Path 13167",
    d: "M392.277,247.328c.1.154.2.3.3.458.1-.388.208-.8.312-1.2-.021-.032-.043-.066-.066-.1C392.644,246.763,392.463,247.043,392.277,247.328Z",
    transform: "translate(-362.363 -242.678)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13168",
    "data-name": "Path 13168",
    d: "M416.537,247.858c-.171.266-.346.54-.523.811.177.273.352.541.523.814.179-.273.353-.541.526-.814C416.89,248.4,416.716,248.124,416.537,247.858Z",
    transform: "translate(-406.004 -242.925)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13169",
    "data-name": "Path 13169",
    d: "M412.94,250.545c-.194.3-.386.595-.575.9.124.189.241.377.37.561.143-.007.284-.013.426-.018.122-.182.239-.362.363-.543C413.328,251.139,413.136,250.843,412.94,250.545Z",
    transform: "translate(-399.473 -243.409)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13170",
    "data-name": "Path 13170",
    d: "M393.968,249.265c-.169.267-.349.544-.522.817q.26.408.522.815a1.671,1.671,0,0,0,.28-.271c.094-.158.2-.312.3-.46C394.355,249.87,394.164,249.568,393.968,249.265Z",
    transform: "translate(-364.988 -243.179)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13171",
    "data-name": "Path 13171",
    d: "M410.258,252.156c.1-.007.191-.007.28-.016-.043-.067-.085-.136-.136-.208C410.355,252,410.311,252.076,410.258,252.156Z",
    transform: "translate(-394.759 -243.659)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13172",
    "data-name": "Path 13172",
    d: "M411.177,250.609c-.179.277-.363.563-.543.848.1.162.213.33.321.5.137-.006.274-.013.415-.021.118-.177.222-.344.334-.514C411.526,251.151,411.36,250.879,411.177,250.609Z",
    transform: "translate(-396.233 -243.421)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13173",
    "data-name": "Path 13173",
    d: "M409.378,250.506c-.19.3-.384.6-.581.9.107.161.2.305.3.462.193,0,.38-.011.568-.024.1-.145.2-.293.285-.438C409.764,251.1,409.571,250.8,409.378,250.506Z",
    transform: "translate(-392.975 -243.402)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13174",
    "data-name": "Path 13174",
    d: "M411.969,252.225c.111,0,.214-.007.321-.014-.054-.075-.107-.161-.159-.241C412.08,252.056,412.027,252.139,411.969,252.225Z",
    transform: "translate(-397.914 -243.666)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13175",
    "data-name": "Path 13175",
    d: "M402.05,250.593c-.2.3-.391.6-.585.893.025.044.061.084.085.13.341-.013.694-.038,1.018-.046.017-.026.035-.058.055-.084C402.432,251.188,402.244,250.889,402.05,250.593Z",
    transform: "translate(-379.634 -243.418)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13176",
    "data-name": "Path 13176",
    d: "M403.9,250.693c-.194.308-.393.613-.595.918.02.032.039.059.062.091.326-.018.651-.032.962-.042.039-.055.065-.1.1-.157C404.249,251.231,404.079,250.959,403.9,250.693Z",
    transform: "translate(-382.946 -243.436)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13177",
    "data-name": "Path 13177",
    d: "M415.067,244.647l.58.9c.184-.285.364-.562.544-.843-.04-.062-.077-.123-.115-.179l-1,.125C415.067,244.646,415.067,244.647,415.067,244.647Z",
    transform: "translate(-404.355 -242.325)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13178",
    "data-name": "Path 13178",
    d: "M408.464,252.076c.059,0,.123,0,.19,0a.8.8,0,0,1-.093-.141C408.523,251.979,408.5,252.032,408.464,252.076Z",
    transform: "translate(-391.404 -243.659)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13179",
    "data-name": "Path 13179",
    d: "M407.468,250.609c-.177.27-.352.542-.525.811.082.133.168.263.252.4.264-.012.533-.024.8-.039.037-.06.075-.119.114-.183C407.9,251.268,407.679,250.939,407.468,250.609Z",
    transform: "translate(-389.609 -243.421)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13180",
    "data-name": "Path 13180",
    d: "M391.822,244.652c.176.271.349.544.519.812.114-.171.225-.34.335-.513.038-.153.066-.3.1-.442-.141-.222-.285-.447-.428-.668Q392.093,244.241,391.822,244.652Z",
    transform: "translate(-361.883 -242.202)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13181",
    "data-name": "Path 13181",
    d: "M407.848,244.5c.189.289.384.59.576.887.2-.309.4-.614.6-.919-.17-.267-.344-.531-.513-.791l-.142.018C408.2,243.958,408.023,244.225,407.848,244.5Z",
    transform: "translate(-391.267 -242.174)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13182",
    "data-name": "Path 13182",
    d: "M409.382,244.24c.1-.161.207-.316.312-.477l-.582.074Z",
    transform: "translate(-392.975 -242.188)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13183",
    "data-name": "Path 13183",
    d: "M409.716,244.587c.182.281.362.566.553.843.193-.3.388-.6.572-.887-.131-.219-.269-.434-.412-.647l-.284.039Q409.932,244.257,409.716,244.587Z",
    transform: "translate(-394.618 -242.212)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13184",
    "data-name": "Path 13184",
    d: "M407.468,244.171c.142-.219.283-.441.429-.656l-.792.1C407.224,243.8,407.337,243.984,407.468,244.171Z",
    transform: "translate(-389.533 -242.144)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13185",
    "data-name": "Path 13185",
    d: "M411.513,244.542c.186.3.375.6.567.895.184-.273.359-.542.533-.811-.116-.173-.221-.344-.335-.516l-.533.064C411.67,244.3,411.591,244.421,411.513,244.542Z",
    transform: "translate(-397.863 -242.251)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13186",
    "data-name": "Path 13186",
    d: "M413.07,244.3a.1.1,0,0,0,.026-.044l-.05,0A.125.125,0,0,1,413.07,244.3Z",
    transform: "translate(-399.603 -242.277)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13187",
    "data-name": "Path 13187",
    d: "M391.816,243.9c.117-.562.2-.932.2-.932a1.042,1.042,0,0,0-.118-.237c-.137.205-.278.421-.423.635C391.585,243.55,391.7,243.725,391.816,243.9Z",
    transform: "translate(-360.83 -242.003)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13188",
    "data-name": "Path 13188",
    d: "M405.655,244.047c.171-.253.339-.514.507-.767l-.918.116C405.377,243.619,405.513,243.832,405.655,244.047Z",
    transform: "translate(-386.271 -242.101)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13189",
    "data-name": "Path 13189",
    d: "M411.221,244.337c.071-.121.147-.229.212-.338l-.393.052C411.1,244.147,411.162,244.237,411.221,244.337Z",
    transform: "translate(-396.297 -242.231)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13190",
    "data-name": "Path 13190",
    d: "M413.291,244.661c.182.269.35.538.532.811.194-.3.386-.6.575-.895-.056-.089-.114-.18-.173-.27l-.76.09C413.407,244.488,413.355,244.569,413.291,244.661Z",
    transform: "translate(-401.106 -242.286)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13191",
    "data-name": "Path 13191",
    d: "M397.95,243.236c.174.265.348.538.523.808.175-.276.356-.543.524-.808-.168-.265-.335-.521-.5-.779l-.047.008C398.285,242.714,398.119,242.971,397.95,243.236Z",
    transform: "translate(-373.126 -241.953)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13192",
    "data-name": "Path 13192",
    d: "M395.676,242.889c.187-.281.366-.571.549-.841h0l-1.009.125C395.366,242.41,395.518,242.648,395.676,242.889Z",
    transform: "translate(-368.112 -241.88)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13193",
    "data-name": "Path 13193",
    d: "M397.572,242.933c.143-.221.276-.434.415-.642l-.766.092C397.338,242.568,397.455,242.744,397.572,242.933Z",
    transform: "translate(-371.518 -241.923)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13194",
    "data-name": "Path 13194",
    d: "M392.438,242.952c.136-.211.273-.421.4-.621a1.629,1.629,0,0,0-.865-.44c-.039.054-.08.106-.119.166C392.05,242.355,392.245,242.648,392.438,242.952Z",
    transform: "translate(-361.97 -241.851)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13195",
    "data-name": "Path 13195",
    d: "M401.5,243.169c.207.321.42.65.636.98.18-.282.367-.567.541-.84-.092-.15-.186-.3-.285-.448l-.761.1A2.069,2.069,0,0,0,401.5,243.169Z",
    transform: "translate(-379.722 -242.026)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13196",
    "data-name": "Path 13196",
    d: "M403.381,243.206c.194.289.39.588.581.885.2-.3.389-.6.571-.885-.025-.048-.052-.093-.078-.139l-1.074.129Z",
    transform: "translate(-383.115 -242.063)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13197",
    "data-name": "Path 13197",
    d: "M401.213,243.019a2.2,2.2,0,0,1,.164-.248l-.3.035C401.123,242.875,401.166,242.947,401.213,243.019Z",
    transform: "translate(-378.073 -242.01)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13198",
    "data-name": "Path 13198",
    d: "M399.654,243.272c.19.292.376.588.571.887.191-.3.389-.6.582-.887-.136-.209-.272-.417-.4-.614l-.39.044C399.9,242.887,399.77,243.078,399.654,243.272Z",
    transform: "translate(-376.333 -241.989)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13199",
    "data-name": "Path 13199",
    d: "M405.723,246.663c.2-.3.389-.6.585-.887-.2-.305-.389-.6-.585-.895-.185.293-.38.59-.575.895C405.335,246.065,405.529,246.363,405.723,246.663Z",
    transform: "translate(-386.339 -242.39)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13200",
    "data-name": "Path 13200",
    d: "M405.669,250.722c-.186.3-.382.6-.567.895a1,1,0,0,0,.1.155c.329-.01.654-.032.988-.042a1.1,1.1,0,0,1,.066-.113C406.059,251.321,405.866,251.019,405.669,250.722Z",
    transform: "translate(-386.247 -243.441)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13201",
    "data-name": "Path 13201",
    d: "M428.349,257.566c-.2.3-.389.6-.578.892l1.121.052a.262.262,0,0,0,.032-.044C428.736,258.169,428.541,257.87,428.349,257.566Z",
    transform: "translate(-427.505 -244.673)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13202",
    "data-name": "Path 13202",
    d: "M426.517,254.8c-.173.28-.347.554-.524.815.194.305.389.606.577.9.175-.266.349-.536.531-.819C426.906,255.407,426.712,255.114,426.517,254.8Z",
    transform: "translate(-424.225 -244.176)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13203",
    "data-name": "Path 13203",
    d: "M424.131,255.7c.2.312.4.626.6.927.192-.294.381-.59.581-.891-.2-.313-.4-.624-.6-.936C424.512,255.114,424.328,255.407,424.131,255.7Z",
    transform: "translate(-420.907 -244.176)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13204",
    "data-name": "Path 13204",
    d: "M423.278,251.486c.194.3.382.6.576.9.188-.3.382-.594.576-.9l-.582-.893C423.66,250.889,423.467,251.188,423.278,251.486Z",
    transform: "translate(-419.328 -243.418)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13205",
    "data-name": "Path 13205",
    d: "M425.056,257.05c.2.318.4.631.593.927.168-.257.349-.53.524-.815-.2-.305-.393-.615-.595-.926C425.4,256.516,425.222,256.786,425.056,257.05Z",
    transform: "translate(-422.528 -244.434)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13206",
    "data-name": "Path 13206",
    d: "M397.26,243.211q-.293-.451-.582-.891c-.183.289-.376.586-.576.891.187.292.383.588.576.887Q396.968,243.65,397.26,243.211Z",
    transform: "translate(-369.872 -241.929)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13207",
    "data-name": "Path 13207",
    d: "M423.525,250.16c-.2-.3-.381-.6-.577-.9-.175.267-.348.544-.524.817.2.294.389.594.576.892C423.173,250.7,423.351,250.431,423.525,250.16Z",
    transform: "translate(-417.722 -243.179)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13208",
    "data-name": "Path 13208",
    d: "M413.747,252.3c.144,0,.282-.008.424-.016-.073-.1-.139-.2-.2-.313C413.891,252.083,413.827,252.195,413.747,252.3Z",
    transform: "translate(-401.253 -243.666)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13209",
    "data-name": "Path 13209",
    d: "M424.195,252.861c.2.306.389.6.579.9.18-.283.362-.568.548-.85-.193-.3-.387-.6-.585-.9C424.557,252.3,424.378,252.581,424.195,252.861Z",
    transform: "translate(-420.971 -243.674)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13210",
    "data-name": "Path 13210",
    d: "M429.02,256.668c-.156.657-.264,1.168-.325,1.431.208-.316.408-.634.622-.971C429.218,256.981,429.124,256.826,429.02,256.668Z",
    transform: "translate(-428.656 -244.511)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13211",
    "data-name": "Path 13211",
    d: "M400.243,246.812c.189-.288.376-.566.552-.841-.176-.277-.353-.546-.526-.811-.182.276-.362.558-.546.843C399.893,246.274,400.074,246.537,400.243,246.812Z",
    transform: "translate(-376.377 -242.44)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13212",
    "data-name": "Path 13212",
    d: "M398.463,246.844c.2-.3.383-.6.576-.891-.193-.3-.38-.6-.576-.9-.189.293-.383.586-.576.9Z",
    transform: "translate(-373.115 -242.421)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13213",
    "data-name": "Path 13213",
    d: "M399.9,244.551q-.262-.415-.522-.811c-.189.289-.385.589-.578.887.169.269.35.542.517.811C399.521,245.137,399.71,244.84,399.9,244.551Z",
    transform: "translate(-374.73 -242.184)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13214",
    "data-name": "Path 13214",
    d: "M398.132,244.634c-.2-.305-.386-.6-.575-.894-.173.265-.351.528-.531.811.2.289.387.59.584.887C397.784,245.163,397.957,244.9,398.132,244.634Z",
    transform: "translate(-371.503 -242.184)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13215",
    "data-name": "Path 13215",
    d: "M403.943,246.78c.175-.276.351-.544.526-.809-.222-.334-.426-.662-.636-.991-.18.262-.349.535-.531.814C403.516,246.12,403.728,246.45,403.943,246.78Z",
    transform: "translate(-382.985 -242.407)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13216",
    "data-name": "Path 13216",
    d: "M403.6,244.547c-.208-.329-.426-.658-.634-.983-.188.29-.382.582-.584.887.221.329.428.658.645.992Z",
    transform: "translate(-381.37 -242.152)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13217",
    "data-name": "Path 13217",
    d: "M405.4,244.451c-.2-.3-.391-.6-.577-.887-.175.261-.344.534-.523.809.194.292.381.59.576.9C405.045,244.987,405.227,244.716,405.4,244.451Z",
    transform: "translate(-384.729 -242.152)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13218",
    "data-name": "Path 13218",
    d: "M402.05,246.882c.194-.3.388-.594.572-.891-.191-.3-.379-.6-.572-.9-.2.291-.383.588-.585.9C401.659,246.288,401.854,246.586,402.05,246.882Z",
    transform: "translate(-379.634 -242.428)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13219",
    "data-name": "Path 13219",
    d: "M401.707,244.627c-.194-.3-.382-.6-.576-.887-.182.269-.361.556-.553.839.2.3.382.6.581.9C401.344,245.187,401.528,244.9,401.707,244.627Z",
    transform: "translate(-377.992 -242.184)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13220",
    "data-name": "Path 13220",
    d: "M425.08,254.277c.188.309.383.607.576.9.187-.3.381-.594.575-.9l-.581-.889C425.456,253.683,425.268,253.98,425.08,254.277Z",
    transform: "translate(-422.606 -243.921)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13221",
    "data-name": "Path 13221",
    d: "M418.3,247.755c-.192.3-.39.6-.576.9.186.3.385.6.576.893l.581-.893Z",
    transform: "translate(-409.219 -242.907)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13222",
    "data-name": "Path 13222",
    d: "M419.107,252.716a2.173,2.173,0,0,1,.61-.16h.014c-.084-.139-.169-.275-.261-.409C419.348,252.339,419.225,252.53,419.107,252.716Z",
    transform: "translate(-411.208 -243.697)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13223",
    "data-name": "Path 13223",
    d: "M420.577,252.961c.129.2.261.4.381.594a7.66,7.66,0,0,1,.708-.527c-.183-.292-.376-.585-.563-.881C420.926,252.426,420.752,252.7,420.577,252.961Z",
    transform: "translate(-414.348 -243.697)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13224",
    "data-name": "Path 13224",
    d: "M418.419,250.609c-.212.33-.429.659-.635.987.135.221.281.442.414.657a1.914,1.914,0,0,0,.221-.015c.169-.272.351-.545.53-.818C418.77,251.151,418.6,250.879,418.419,250.609Z",
    transform: "translate(-409.341 -243.421)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13225",
    "data-name": "Path 13225",
    d: "M421.714,254.374c.065.112.128.213.207.326.226-.245.467-.481.7-.7l-.337-.514C422.086,253.78,421.9,254.077,421.714,254.374Z",
    transform: "translate(-416.235 -243.938)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13226",
    "data-name": "Path 13226",
    d: "M423.255,254.286c.212.315.4.622.6.927.182-.276.361-.558.549-.847-.2-.3-.394-.614-.6-.927C423.618,253.728,423.439,254.011,423.255,254.286Z",
    transform: "translate(-419.281 -243.93)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13227",
    "data-name": "Path 13227",
    d: "M417.181,252.453c.2-.007.417-.022.663-.037-.112-.161-.222-.321-.32-.485C417.411,252.108,417.3,252.284,417.181,252.453Z",
    transform: "translate(-407.742 -243.659)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13228",
    "data-name": "Path 13228",
    d: "M415.413,252.372c.175,0,.362-.017.544-.023-.084-.145-.171-.277-.261-.418C415.6,252.076,415.5,252.226,415.413,252.372Z",
    transform: "translate(-404.405 -243.659)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13229",
    "data-name": "Path 13229",
    d: "M416.521,250.506c-.185.3-.381.6-.573.9.162.249.321.5.479.741.065,0,.129-.007.207-.007.157-.244.311-.485.468-.735C416.9,251.1,416.711,250.8,416.521,250.506Z",
    transform: "translate(-405.988 -243.402)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13230",
    "data-name": "Path 13230",
    d: "M414.736,250.609c-.179.27-.348.542-.522.811.14.225.29.45.432.667.079,0,.156,0,.232-.007.139-.209.273-.419.4-.622C415.1,251.172,414.918,250.886,414.736,250.609Z",
    transform: "translate(-402.746 -243.421)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13231",
    "data-name": "Path 13231",
    d: "M421.479,251.5c.208.308.4.622.6.925.18-.265.35-.535.53-.818-.2-.305-.4-.61-.594-.918C421.832,250.959,421.658,251.231,421.479,251.5Z",
    transform: "translate(-416.029 -243.436)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13232",
    "data-name": "Path 13232",
    d: "M421.138,249.265c-.193.3-.388.595-.576.9.2.308.4.613.6.925.187-.3.38-.6.576-.895C421.539,249.88,421.33,249.568,421.138,249.265Z",
    transform: "translate(-414.404 -243.179)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13233",
    "data-name": "Path 13233",
    d: "M419.648,251.617c.2.305.391.6.585.9.185-.3.38-.6.567-.9-.187-.3-.382-.6-.567-.895C420.039,251.019,419.846,251.321,419.648,251.617Z",
    transform: "translate(-412.721 -243.441)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13234",
    "data-name": "Path 13234",
    d: "M418.643,250.175c.2.3.391.6.584.895.214-.329.426-.662.641-.995-.2-.3-.38-.6-.578-.9C419.073,249.51,418.864,249.844,418.643,250.175Z",
    transform: "translate(-410.965 -243.163)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13235",
    "data-name": "Path 13235",
    d: "M422.329,252.914c.2.313.4.618.6.927.189-.3.386-.6.581-.9-.2-.3-.4-.614-.6-.919C422.709,252.316,422.524,252.618,422.329,252.914Z",
    transform: "translate(-417.627 -243.674)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13236",
    "data-name": "Path 13236",
    d: "M423.814,257.17a.236.236,0,0,0,.027.052c.186-.248.4-.533.635-.822-.033-.039-.057-.087-.09-.123C424.189,256.582,424,256.879,423.814,257.17Z",
    transform: "translate(-419.812 -244.441)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13237",
    "data-name": "Path 13237",
    d: "M422.819,255.75c.03.057.063.1.1.161.2-.243.406-.49.624-.731-.066-.092-.119-.176-.18-.276C423.179,255.192,423,255.469,422.819,255.75Z",
    transform: "translate(-418.064 -244.194)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13238",
    "data-name": "Path 13238",
    d: "M426.492,257.566c-.2.307-.387.609-.577.9.012.025.031.044.04.062l1.084.047a.525.525,0,0,0,.048-.076C426.894,258.191,426.7,257.88,426.492,257.566Z",
    transform: "translate(-424.147 -244.673)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13239",
    "data-name": "Path 13239",
    d: "M424.81,258.523s0,.006,0,.006c.089-.13.278-.416.543-.793-.014-.01-.014-.024-.024-.032C425.149,257.977,424.981,258.253,424.81,258.523Z",
    transform: "translate(-421.511 -244.698)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13240",
    "data-name": "Path 13240",
    d: "M399.34,242.975c.1-.157.2-.305.29-.449l-.545.062C399.178,242.717,399.252,242.847,399.34,242.975Z",
    transform: "translate(-374.69 -241.966)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13241",
    "data-name": "Path 13241",
    d: "M423.525,247.327c-.174-.271-.353-.54-.526-.809-.186.3-.38.593-.576.891.176.271.348.542.524.818C423.144,247.93,423.329,247.624,423.525,247.327Z",
    transform: "translate(-417.722 -242.684)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13242",
    "data-name": "Path 13242",
    d: "M427.973,254.294c-.174-.266-.351-.54-.524-.811-.184.271-.353.544-.532.811.18.273.356.546.532.821C427.616,254.847,427.8,254.579,427.973,254.294Z",
    transform: "translate(-425.854 -243.938)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13243",
    "data-name": "Path 13243",
    d: "M427.1,252.868c-.182-.268-.348-.545-.531-.81-.2.3-.387.6-.577.9.177.273.351.544.524.818C426.712,253.472,426.9,253.174,427.1,252.868Z",
    transform: "translate(-424.225 -243.681)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13244",
    "data-name": "Path 13244",
    d: "M395.764,245.475c.2-.3.39-.6.585-.888-.189-.287-.368-.57-.549-.847-.189.289-.385.589-.584.887C395.4,244.908,395.585,245.193,395.764,245.475Z",
    transform: "translate(-368.236 -242.184)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13245",
    "data-name": "Path 13245",
    d: "M424.719,250.974c.2-.3.392-.6.585-.892-.18-.273-.349-.549-.528-.817-.2.3-.383.595-.581.9C424.374,250.431,424.549,250.7,424.719,250.974Z",
    transform: "translate(-420.953 -243.179)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13246",
    "data-name": "Path 13246",
    d: "M424.391,248.753c-.18-.271-.349-.546-.53-.817-.17.271-.349.546-.519.817.17.273.349.539.519.809C424.042,249.291,424.21,249.026,424.391,248.753Z",
    transform: "translate(-419.34 -242.939)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13247",
    "data-name": "Path 13247",
    d: "M397,247.37l.544.85c.2-.3.387-.6.584-.893-.181-.285-.366-.565-.544-.849C397.387,246.774,397.2,247.071,397,247.37Z",
    transform: "translate(-371.477 -242.677)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13248",
    "data-name": "Path 13248",
    d: "M395.431,243.228c-.189-.285-.368-.568-.553-.85-.18.274-.362.551-.548.844.18.28.36.563.548.84C395.067,243.779,395.249,243.5,395.431,243.228Z",
    transform: "translate(-366.592 -241.939)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13249",
    "data-name": "Path 13249",
    d: "M426.214,248.737c-.193-.3-.388-.592-.574-.891-.194.3-.39.594-.584.891.193.3.389.6.584.893C425.831,249.333,426.021,249.034,426.214,248.737Z",
    transform: "translate(-422.569 -242.923)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13250",
    "data-name": "Path 13250",
    d: "M427.431,256.132c-.2.309-.39.608-.585.9.2.305.389.6.585.9.185-.291.373-.589.582-.9C427.82,256.738,427.625,256.441,427.431,256.132Z",
    transform: "translate(-425.837 -244.415)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13251",
    "data-name": "Path 13251",
    d: "M394,245.477c.188-.288.366-.567.548-.84-.193-.3-.386-.6-.584-.888-.174.271-.353.549-.542.832C393.612,244.877,393.8,245.179,394,245.477Z",
    transform: "translate(-364.956 -242.186)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13252",
    "data-name": "Path 13252",
    d: "M396.662,247.846c-.189.3-.382.594-.577.891.2.3.389.6.577.893.193-.3.384-.6.576-.893Z",
    transform: "translate(-369.838 -242.923)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13253",
    "data-name": "Path 13253",
    d: "M393.513,241.961a.409.409,0,0,0-.034.05c.18.28.364.56.552.849.18-.281.353-.552.524-.811-.038-.071-.091-.137-.132-.205a3.452,3.452,0,0,0-.671.089Z",
    transform: "translate(-365.017 -241.843)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13254",
    "data-name": "Path 13254",
    d: "M395.234,250.166c.176.27.35.542.523.808.194-.3.384-.6.576-.892-.169-.273-.348-.549-.514-.817C395.623,249.563,395.428,249.859,395.234,250.166Z",
    transform: "translate(-368.235 -243.179)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13255",
    "data-name": "Path 13255",
    d: "M397,250.115c.2.3.387.594.578.895.184-.285.368-.566.549-.843-.2-.3-.389-.6-.584-.9C397.362,249.55,397.18,249.829,397,250.115Z",
    transform: "translate(-371.477 -243.179)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13256",
    "data-name": "Path 13256",
    d: "M393.664,243.311c-.194-.289-.389-.595-.569-.883-.171.257-.351.524-.53.8.194.3.381.6.576.893C393.315,243.853,393.5,243.58,393.664,243.311Z",
    transform: "translate(-363.377 -241.948)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13257",
    "data-name": "Path 13257",
    d: "M394.372,248.755c.175.273.352.54.526.817.177-.276.35-.544.525-.817-.175-.271-.348-.538-.525-.806C394.724,248.209,394.547,248.484,394.372,248.755Z",
    transform: "translate(-366.617 -242.942)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13258",
    "data-name": "Path 13258",
    d: "M392.565,246.009c.173.265.351.534.524.809.186-.287.371-.572.549-.841-.179-.276-.349-.544-.531-.813C392.936,245.436,392.752,245.719,392.565,246.009Z",
    transform: "translate(-363.351 -242.44)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13259",
    "data-name": "Path 13259",
    d: "M393.446,247.41c.169.271.349.542.518.818.2-.3.387-.6.585-.893-.178-.271-.351-.547-.525-.811C393.833,246.814,393.64,247.112,393.446,247.41Z",
    transform: "translate(-364.984 -242.685)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13260",
    "data-name": "Path 13260",
    d: "M426.183,251.5c-.176-.273-.354-.545-.526-.811-.182.278-.362.566-.543.843.166.273.348.541.522.818C425.811,252.07,425.994,251.789,426.183,251.5Z",
    transform: "translate(-422.587 -243.436)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13261",
    "data-name": "Path 13261",
    d: "M412.031,248.133c.193-.3.387-.6.578-.893-.185-.285-.371-.566-.554-.85q-.277.446-.567.9C411.667,247.569,411.851,247.845,412.031,248.133Z",
    transform: "translate(-397.837 -242.661)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13262",
    "data-name": "Path 13262",
    d: "M410.288,248.142c.178-.273.352-.544.524-.817-.19-.3-.386-.6-.572-.887-.178.265-.35.538-.524.811C409.91,247.546,410.1,247.843,410.288,248.142Z",
    transform: "translate(-394.589 -242.67)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13263",
    "data-name": "Path 13263",
    d: "M411.7,245.924c-.18-.289-.366-.571-.549-.849-.175.263-.344.536-.524.809.18.276.364.562.543.847C411.358,246.457,411.531,246.187,411.7,245.924Z",
    transform: "translate(-396.23 -242.424)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13264",
    "data-name": "Path 13264",
    d: "M413.524,245.864c-.2-.3-.389-.594-.585-.9-.185.3-.38.6-.575.9.189.3.381.594.575.891C413.136,246.458,413.328,246.16,413.524,245.864Z",
    transform: "translate(-399.473 -242.405)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13265",
    "data-name": "Path 13265",
    d: "M408.114,245.793c-.165-.271-.348-.544-.515-.814-.2.3-.4.606-.6.927.171.263.355.534.522.807C407.727,246.4,407.924,246.091,408.114,245.793Z",
    transform: "translate(-389.664 -242.407)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13266",
    "data-name": "Path 13266",
    d: "M407.174,244.373c-.178-.275-.356-.54-.524-.809l-.577.887c.176.273.341.535.522.809C406.793,244.963,406.984,244.664,407.174,244.373Z",
    transform: "translate(-387.964 -242.152)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13267",
    "data-name": "Path 13267",
    d: "M413.863,248.133c.183-.289.372-.564.551-.847-.193-.3-.388-.6-.575-.9-.182.284-.362.564-.549.85C413.481,247.537,413.669,247.834,413.863,248.133Z",
    transform: "translate(-401.122 -242.661)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13268",
    "data-name": "Path 13268",
    d: "M408.464,248.142c.194-.3.389-.6.575-.893-.175-.273-.348-.546-.524-.811-.193.291-.387.588-.576.887Z",
    transform: "translate(-391.357 -242.67)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13269",
    "data-name": "Path 13269",
    d: "M409.952,245.912c-.189-.305-.381-.6-.571-.9l-.585.9c.2.289.39.585.585.883C409.578,246.5,409.769,246.2,409.952,245.912Z",
    transform: "translate(-392.975 -242.412)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13270",
    "data-name": "Path 13270",
    d: "M417.1,245.9q-.3-.445-.581-.9c-.185.3-.381.6-.573.9.184.289.383.585.573.883Q416.805,246.348,417.1,245.9Z",
    transform: "translate(-405.988 -242.412)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13271",
    "data-name": "Path 13271",
    d: "M418.909,245.906c-.2-.321-.393-.626-.594-.927-.177.271-.344.535-.523.814.193.3.392.609.594.92C418.559,246.44,418.736,246.17,418.909,245.906Z",
    transform: "translate(-409.306 -242.407)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13272",
    "data-name": "Path 13272",
    d: "M415.288,245.883c-.176-.273-.35-.546-.517-.809-.182.279-.371.56-.557.849.18.263.35.534.529.807C414.926,246.445,415.108,246.16,415.288,245.883Z",
    transform: "translate(-402.753 -242.424)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13273",
    "data-name": "Path 13273",
    d: "M419.813,247.225c-.2-.313-.4-.622-.6-.919-.192.289-.383.59-.573.886.19.31.388.615.592.926C419.433,247.819,419.618,247.522,419.813,247.225Z",
    transform: "translate(-410.91 -242.646)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13274",
    "data-name": "Path 13274",
    d: "M421.724,247.192l-.576-.886c-.215.321-.428.65-.641.983.188.3.383.594.576.9C421.3,247.853,421.511,247.522,421.724,247.192Z",
    transform: "translate(-414.349 -242.646)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13275",
    "data-name": "Path 13275",
    d: "M420.169,249.636c.206-.331.425-.663.635-.991-.194-.312-.394-.615-.6-.922-.207.333-.426.66-.642.991C419.767,249.018,419.968,249.33,420.169,249.636Z",
    transform: "translate(-412.658 -242.901)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13276",
    "data-name": "Path 13276",
    d: "M415.625,248.142c.2-.3.381-.6.572-.893-.17-.273-.35-.546-.52-.811-.193.291-.388.588-.58.887C415.271,247.6,415.445,247.869,415.625,248.142Z",
    transform: "translate(-404.385 -242.67)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13277",
    "data-name": "Path 13277",
    d: "M417.436,248.142c.18-.273.357-.544.531-.817-.2-.3-.391-.6-.585-.887-.168.265-.347.538-.517.811C417.054,247.546,417.247,247.843,417.436,248.142Z",
    transform: "translate(-407.606 -242.67)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13278",
    "data-name": "Path 13278",
    d: "M422.092,249.629c.187-.3.38-.6.57-.893-.189-.3-.383-.592-.57-.891-.194.3-.389.594-.584.891Z",
    transform: "translate(-416.108 -242.923)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13279",
    "data-name": "Path 13279",
    d: "M402.063,247.936c-.178.271-.349.546-.531.817.183.273.349.54.531.817.167-.278.349-.544.517-.817C402.413,248.482,402.231,248.207,402.063,247.936Z",
    transform: "translate(-379.647 -242.939)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13280",
    "data-name": "Path 13280",
    d: "M407.592,247.755c-.2.3-.38.6-.578.9.2.3.383.6.578.893.191-.3.389-.6.581-.893C407.982,248.354,407.783,248.053,407.592,247.755Z",
    transform: "translate(-389.734 -242.907)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13281",
    "data-name": "Path 13281",
    d: "M411.487,250.026c.186.3.383.6.567.894q.276-.418.554-.845c-.191-.3-.385-.6-.578-.9C411.851,249.465,411.667,249.739,411.487,250.026Z",
    transform: "translate(-397.837 -243.163)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13282",
    "data-name": "Path 13282",
    d: "M413.291,250.075c.186.285.367.566.549.845.194-.3.382-.6.575-.894-.189-.287-.368-.561-.551-.846C413.669,249.478,413.481,249.771,413.291,250.075Z",
    transform: "translate(-401.122 -243.163)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13283",
    "data-name": "Path 13283",
    d: "M414.754,247.755c-.194.3-.386.6-.581.9.194.3.386.6.581.893.2-.3.387-.6.579-.893C415.141,248.354,414.949,248.053,414.754,247.755Z",
    transform: "translate(-402.764 -242.907)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13284",
    "data-name": "Path 13284",
    d: "M412.954,247.811c-.179.287-.363.563-.543.849.18.285.364.562.543.847.183-.285.363-.562.547-.847C413.317,248.374,413.137,248.1,412.954,247.811Z",
    transform: "translate(-399.487 -242.917)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13285",
    "data-name": "Path 13285",
    d: "M411.14,247.755c-.189.3-.382.6-.575.9.193.3.381.6.575.893.194-.3.389-.6.584-.893C411.528,248.354,411.333,248.053,411.14,247.755Z",
    transform: "translate(-396.196 -242.907)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13286",
    "data-name": "Path 13286",
    d: "M407.938,249.994c.194.3.389.594.581.9.169-.268.349-.546.524-.814-.194-.3-.381-.594-.575-.9C408.293,249.448,408.118,249.721,407.938,249.994Z",
    transform: "translate(-391.362 -243.163)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13287",
    "data-name": "Path 13287",
    d: "M409.39,247.858c-.183.266-.349.54-.529.811.18.273.346.541.525.814.174-.273.354-.541.522-.814C409.74,248.4,409.56,248.124,409.39,247.858Z",
    transform: "translate(-392.984 -242.925)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13288",
    "data-name": "Path 13288",
    d: "M409.716,250.075c.174.276.346.546.516.814.194-.3.39-.6.581-.9-.172-.273-.346-.546-.524-.814C410.1,249.478,409.91,249.771,409.716,250.075Z",
    transform: "translate(-394.589 -243.163)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13289",
    "data-name": "Path 13289",
    d: "M415.1,249.994c.192.3.387.594.58.9.17-.268.35-.538.52-.814-.19-.3-.382-.6-.572-.9C415.445,249.448,415.276,249.721,415.1,249.994Z",
    transform: "translate(-404.385 -243.163)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13290",
    "data-name": "Path 13290",
    d: "M421.179,245.61a.64.64,0,0,1,.067-.1.611.611,0,0,1-.119.032A.743.743,0,0,1,421.179,245.61Z",
    transform: "translate(-414.379 -242.503)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13291",
    "data-name": "Path 13291",
    d: "M396.148,245.971c.181.276.363.56.552.847.171-.281.346-.544.517-.809-.181-.285-.363-.573-.544-.849C396.5,245.425,396.321,245.694,396.148,245.971Z",
    transform: "translate(-369.867 -242.44)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13292",
    "data-name": "Path 13292",
    d: "M423.616,247.1c.181-.273.358-.544.53-.816-.27.116-.543.245-.8.389C423.433,246.813,423.526,246.952,423.616,247.1Z",
    transform: "translate(-419.095 -242.641)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13293",
    "data-name": "Path 13293",
    d: "M419.581,245.841l.576.887c.194-.3.386-.6.584-.887-.13-.208-.258-.4-.39-.6-.151.034-.3.075-.453.112C419.789,245.516,419.685,245.673,419.581,245.841Z",
    transform: "translate(-412.607 -242.455)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13294",
    "data-name": "Path 13294",
    d: "M428.162,256.524c.18-.294.375-.59.567-.9-.169-.267-.348-.535-.517-.815-.089.133-.168.262-.253.391-.064.255-.122.5-.18.737C427.9,256.134,428.03,256.33,428.162,256.524Z",
    transform: "translate(-427.318 -244.176)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13295",
    "data-name": "Path 13295",
    d: "M427.143,252.457c.185-.3.382-.594.572-.9-.16-.245-.312-.49-.482-.743-.128.381-.25.787-.373,1.2C426.946,252.168,427.045,252.308,427.143,252.457Z",
    transform: "translate(-425.548 -243.458)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13296",
    "data-name": "Path 13296",
    d: "M427.791,253.893c.169-.273.344-.544.517-.818-.062-.11-.141-.225-.212-.339-.11.383-.212.764-.316,1.141Z",
    transform: "translate(-426.898 -243.804)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13297",
    "data-name": "Path 13297",
    d: "M424.756,248.3c.179-.276.348-.546.528-.818-.121-.186-.245-.369-.362-.552a5.8,5.8,0,0,0-.727.5C424.385,247.727,424.571,248.01,424.756,248.3Z",
    transform: "translate(-420.933 -242.759)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13298",
    "data-name": "Path 13298",
    d: "M426.511,251.009c.183-.285.363-.566.544-.849-.194-.3-.387-.6-.576-.9-.124.2-.252.4-.384.595-.038.1-.075.209-.117.316C426.153,250.457,426.329,250.725,426.511,251.009Z",
    transform: "translate(-424.166 -243.179)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13299",
    "data-name": "Path 13299",
    d: "M421.43,246.092c.179.266.353.534.534.809.207-.33.427-.66.634-.986-.053-.089-.1-.176-.162-.261-.3.1-.615.2-.925.32C421.486,246.012,421.459,246.052,421.43,246.092Z",
    transform: "translate(-415.98 -242.529)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13300",
    "data-name": "Path 13300",
    d: "M400.254,247.846c-.189.291-.383.594-.568.891.185.3.38.6.568.893q.29-.445.582-.893C400.641,248.44,400.448,248.144,400.254,247.846Z",
    transform: "translate(-376.388 -242.923)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13301",
    "data-name": "Path 13301",
    d: "M400.609,250.082c.2.294.382.594.581.892.175-.272.348-.543.523-.813-.189-.3-.383-.6-.577-.9C400.962,249.532,400.788,249.809,400.609,250.082Z",
    transform: "translate(-378.022 -243.179)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13302",
    "data-name": "Path 13302",
    d: "M399.929,247.37q-.289-.448-.584-.893c-.18.279-.363.564-.543.849.2.3.389.6.58.893C399.566,247.937,399.749,247.65,399.929,247.37Z",
    transform: "translate(-374.756 -242.677)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13303",
    "data-name": "Path 13303",
    d: "M401.711,247.334c-.181-.271-.354-.547-.529-.816q-.285.443-.581.891c.179.271.353.542.526.818Q401.42,247.769,401.711,247.334Z",
    transform: "translate(-378.015 -242.684)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13304",
    "data-name": "Path 13304",
    d: "M419.221,245.523c.117-.166.222-.335.33-.5l-.575.108C419.055,245.265,419.145,245.395,419.221,245.523Z",
    transform: "translate(-410.92 -242.416)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13305",
    "data-name": "Path 13305",
    d: "M395.453,246c-.193-.307-.387-.6-.581-.9-.182.291-.375.6-.569.9.189.3.377.594.569.891C395.066,246.586,395.261,246.288,395.453,246Z",
    transform: "translate(-366.591 -242.428)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13306",
    "data-name": "Path 13306",
    d: "M395.224,247.335q.29.448.586.893c.171-.276.345-.546.522-.818-.2-.3-.381-.6-.579-.886C395.581,246.788,395.4,247.064,395.224,247.335Z",
    transform: "translate(-368.225 -242.685)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13307",
    "data-name": "Path 13307",
    d: "M402.386,250.16q.263.406.525.813c.194-.3.38-.6.576-.892-.166-.273-.349-.549-.524-.817C402.774,249.563,402.58,249.859,402.386,250.16Z",
    transform: "translate(-381.252 -243.179)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13308",
    "data-name": "Path 13308",
    d: "M398.475,247.9c-.18.277-.367.56-.55.845.183.288.37.564.544.849.191-.285.368-.57.55-.849C398.838,248.468,398.66,248.185,398.475,247.9Z",
    transform: "translate(-373.128 -242.933)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13309",
    "data-name": "Path 13309",
    d: "M398.8,250.16c.18.283.362.564.543.849.2-.3.391-.6.584-.895-.18-.285-.362-.564-.547-.85C399.191,249.563,399,249.859,398.8,250.16Z",
    transform: "translate(-374.756 -243.179)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13310",
    "data-name": "Path 13310",
    d: "M416.9,244.854c.154.241.308.48.463.727q.285-.427.558-.851l-.49.061S417.227,244.812,416.9,244.854Z",
    transform: "translate(-407.586 -242.362)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13311",
    "data-name": "Path 13311",
    d: "M405.673,247.723c-.193.307-.392.61-.6.922.215.329.43.666.634.991.207-.306.4-.618.6-.922C406.1,248.383,405.891,248.056,405.673,247.723Z",
    transform: "translate(-386.29 -242.901)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13312",
    "data-name": "Path 13312",
    d: "M404.156,250.191c.194.3.386.6.583.895.194-.312.388-.617.594-.925-.193-.3-.389-.6-.582-.9C404.557,249.568,404.358,249.88,404.156,250.191Z",
    transform: "translate(-384.55 -243.179)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13313",
    "data-name": "Path 13313",
    d: "M406.017,250.075c.208.333.427.666.631.995.2-.3.388-.6.586-.895-.224-.331-.427-.665-.641-1C406.4,249.478,406.209,249.771,406.017,250.075Z",
    transform: "translate(-387.977 -243.163)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13314",
    "data-name": "Path 13314",
    d: "M407.244,247.195c-.194-.3-.381-.6-.579-.889-.193.3-.4.606-.592.919.192.3.38.594.576.893C406.847,247.807,407.044,247.5,407.244,247.195Z",
    transform: "translate(-388.033 -242.646)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13315",
    "data-name": "Path 13315",
    d: "M405.371,247.3c-.218-.339-.427-.669-.639-.99-.189.289-.383.59-.576.889.205.327.425.658.633.994C404.983,247.884,405.179,247.586,405.371,247.3Z",
    transform: "translate(-384.589 -242.646)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13316",
    "data-name": "Path 13316",
    d: "M403.814,247.846c-.187.291-.381.594-.575.891.194.3.38.6.567.893l.585-.893C404.2,248.44,404,248.144,403.814,247.846Z",
    transform: "translate(-382.856 -242.923)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13317",
    "data-name": "Path 13317",
    d: "M403.486,247.409c-.2-.3-.382-.6-.576-.891-.175.269-.345.539-.525.816l.581.893C403.138,247.951,403.321,247.681,403.486,247.409Z",
    transform: "translate(-381.252 -242.684)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13318",
    "data-name": "Path 13318",
    d: "M393.424,255.7l-.421-.018a.261.261,0,0,0,.032-.044c-.188-.3-.383-.6-.575-.9-.2.3-.389.6-.578.892l-.266,0s.013-.073.039-.194c.208-.316.408-.634.622-.971-.1-.147-.194-.3-.3-.46.033-.127.063-.254.1-.4.124.2.25.4.382.59.18-.294.375-.59.567-.9-.169-.267-.349-.535-.517-.815-.089.133-.168.262-.253.391.08-.305.164-.624.241-.945l.011.015c.169-.273.344-.544.517-.818-.061-.11-.141-.225-.212-.339.032-.119.071-.252.112-.374.087.151.186.291.284.44.185-.3.382-.594.572-.9-.16-.245-.312-.49-.482-.743.046-.117.084-.241.128-.36.175.281.351.549.533.833.183-.285.363-.566.544-.849-.194-.3-.387-.6-.576-.9-.124.2-.252.4-.384.594.1-.277.209-.536.312-.755a3.624,3.624,0,0,1,1.02-1.25c.19.294.376.576.561.868.179-.276.348-.546.528-.818-.121-.186-.245-.369-.362-.552.084-.048.17-.1.258-.146.091.144.184.283.274.427.181-.273.358-.544.53-.816.155-.07.325-.138.48-.194-.025.038-.052.078-.08.118.179.266.353.534.534.809.207-.33.427-.66.634-.986-.053-.089-.1-.176-.162-.261.1-.024.2-.056.292-.084a.737.737,0,0,1,.052.066.642.642,0,0,1,.067-.1c.14-.038.284-.075.426-.107-.11.16-.214.317-.318.485l.576.887c.194-.3.386-.6.584-.887-.13-.208-.258-.4-.389-.6.1-.025.207-.046.311-.07.079.129.169.258.245.387.117-.166.222-.335.33-.5.265-.055.494-.084.682-.121.154.241.308.48.463.727q.285-.427.558-.851l.389-.046c-.011,0-.011,0-.011,0l.58.9c.184-.285.364-.562.544-.843-.04-.062-.077-.123-.115-.179l.638-.084c-.057.09-.11.171-.174.263.182.269.35.538.532.811.194-.3.386-.6.575-.895-.056-.089-.114-.18-.173-.27l.324-.04a.125.125,0,0,1,.024.04.105.105,0,0,0,.026-.044l.389-.054c-.075.125-.154.247-.232.368.186.3.375.6.567.895.184-.273.359-.542.533-.811-.116-.173-.221-.344-.335-.516l.33-.039c.057.1.121.185.18.285.071-.121.147-.229.212-.338l.39-.046q-.213.322-.429.653c.182.281.362.566.553.843.193-.3.388-.6.572-.887-.131-.219-.269-.434-.412-.647l.326-.035.27.4c.1-.161.207-.316.312-.477l.381-.049c-.169.259-.344.526-.519.805.189.289.384.59.576.887.2-.309.4-.614.6-.919-.17-.267-.344-.531-.513-.791l.33-.036c.119.185.232.369.363.556.142-.219.283-.441.429-.656l.608-.077c.133.224.269.436.411.651.171-.253.339-.514.507-.767l.376-.046v.01c.194.289.39.588.581.885.2-.3.389-.6.571-.885-.025-.048-.052-.093-.078-.139l.572-.071a2.069,2.069,0,0,0-.131.209c.207.321.42.65.636.98.18-.282.367-.567.541-.84-.092-.15-.186-.3-.285-.448l.335-.039c.042.069.085.141.132.213a2.2,2.2,0,0,1,.164-.248l.378-.048c-.113.184-.245.376-.361.57.19.292.376.588.571.887.191-.3.389-.6.582-.887-.136-.209-.272-.417-.4-.614l.323-.046c.093.129.167.258.255.387.1-.157.2-.305.29-.449l.388-.048c-.17.249-.335.506-.5.771.174.265.348.538.523.808.175-.276.356-.543.524-.808-.168-.265-.335-.521-.5-.779l.328-.044c.117.185.234.362.351.55.143-.221.276-.434.415-.642l.635-.075c.15.237.3.476.46.717.187-.281.366-.571.549-.841h0l.382-.05a.408.408,0,0,0-.034.05c.18.28.364.56.552.85.18-.281.353-.552.524-.811-.038-.07-.091-.137-.132-.2a2.812,2.812,0,0,1,.6.039c-.039.054-.08.106-.119.166.2.3.39.59.583.894.136-.211.273-.421.4-.621a1.408,1.408,0,0,1,.2.248c-.137.205-.278.421-.423.635.113.184.227.359.344.534-.033.125-.063.257-.09.409-.141-.222-.285-.447-.428-.668q-.258.4-.53.812c.175.271.348.544.519.812.114-.171.225-.34.335-.513-.084.367-.175.758-.27,1.156-.021-.032-.043-.066-.066-.1-.177.278-.358.558-.544.843.1.154.2.3.3.458-.039.13-.075.26-.1.384-.132-.188-.248-.384-.371-.568-.186.3-.383.594-.575.891.18.291.361.576.544.855-.02.058-.045.115-.066.169a3.254,3.254,0,0,1-.38.61c.094-.158.2-.312.3-.46-.2-.3-.389-.6-.585-.9-.169.267-.349.544-.522.817q.26.408.522.815a1.269,1.269,0,0,1-.259.144c-.143-.23-.3-.453-.44-.687-.167.25-.325.5-.493.764-.143.006-.309.011-.517.016-.143-.229-.3-.462-.447-.7-.162.246-.317.494-.486.742-.141,0-.306.016-.467.025-.18-.273-.348-.546-.53-.819-.183.289-.362.578-.55.863-.124.006-.252.012-.39.016-.176-.276-.356-.554-.536-.827-.169.266-.35.538-.523.811a.519.519,0,0,0,.046.064l-.454.02c.017-.026.035-.058.055-.084-.191-.3-.379-.6-.572-.893-.2.3-.391.6-.585.893.025.044.061.084.085.13-.175.009-.353.01-.537.027.039-.055.065-.1.1-.157-.18-.273-.35-.545-.534-.811-.193.308-.393.613-.594.918.02.032.039.059.062.091-.166.006-.321.014-.477.022a1.108,1.108,0,0,1,.066-.113c-.2-.3-.388-.6-.585-.895-.186.3-.382.6-.567.895a1,1,0,0,0,.1.155c-.186.006-.38.022-.569.028.037-.06.075-.119.114-.183-.212-.328-.427-.658-.639-.987-.177.27-.352.542-.525.811.082.133.168.263.252.4-.116.008-.225.008-.335.016a.8.8,0,0,1-.093-.141c-.039.048-.063.1-.1.145-.121.011-.239.011-.368.02.1-.145.2-.293.285-.438-.189-.3-.381-.6-.575-.9-.19.3-.384.6-.581.9.107.161.2.305.3.462-.117.009-.233.012-.344.02-.043-.067-.085-.136-.136-.208-.047.072-.09.145-.143.225-.114,0-.239.008-.362.016.118-.177.222-.344.334-.514-.178-.269-.344-.541-.527-.811-.179.277-.363.563-.543.848.1.162.213.33.321.5-.116.007-.232.007-.346.011-.054-.075-.107-.161-.159-.241-.051.086-.1.169-.162.255-.121.008-.239.014-.367.02.122-.182.239-.362.363-.543-.2-.306-.389-.6-.585-.9-.194.3-.386.595-.575.9.124.189.241.377.37.561-.119.009-.234.012-.344.021-.073-.1-.139-.2-.2-.313-.079.113-.143.225-.223.33-.117.007-.245.016-.362.025.139-.209.273-.419.4-.622-.18-.285-.362-.571-.545-.848-.179.27-.348.542-.522.811.14.225.29.45.432.667l-.348.025c-.084-.145-.171-.277-.261-.418-.094.145-.193.3-.284.441l-.362.02c.157-.244.311-.485.468-.735-.2-.3-.391-.6-.581-.9-.185.3-.381.6-.573.9.162.249.321.5.479.741l-.336.017c-.112-.161-.222-.321-.32-.485-.114.177-.227.353-.344.522-.126.01-.252.02-.361.023.169-.272.351-.545.53-.818-.179-.269-.349-.541-.53-.811-.212.33-.429.659-.635.987.135.221.281.442.414.657-.128.01-.245.018-.334.026-.084-.139-.169-.275-.261-.409-.122.192-.245.383-.363.569a3.567,3.567,0,0,0-.581.312c-.183-.292-.376-.585-.563-.881-.176.279-.351.549-.526.814.129.2.261.4.381.594-.069.071-.148.13-.225.2l-.337-.514c-.2.3-.381.594-.569.891.065.112.128.213.207.326a2.867,2.867,0,0,0-.207.224c-.066-.092-.119-.176-.18-.276-.185.289-.366.566-.544.847.03.057.063.1.1.161-.071.08-.134.165-.192.241-.033-.039-.057-.087-.09-.123-.2.306-.386.6-.572.894a.234.234,0,0,0,.027.052c-.065.089-.121.173-.182.257-.014-.01-.014-.024-.024-.032-.185.273-.353.549-.524.819,0,0,0,.006,0,.006a.7.7,0,0,0-.052.083l-.36-.012a.529.529,0,0,0,.048-.076c-.194-.308-.387-.618-.6-.932-.2.307-.387.609-.577.9C393.4,255.66,393.415,255.679,393.424,255.7Zm.537-1.507c.176-.266.349-.536.531-.819-.2-.3-.389-.59-.585-.9-.173.28-.347.554-.524.815C393.578,253.592,393.773,253.893,393.961,254.19Zm2.175-5.173c-.189.3-.381.6-.571.893.194.3.382.6.576.9.188-.3.382-.594.576-.9Zm.757.62c.173-.272.352-.543.526-.813-.2-.3-.381-.6-.577-.9-.175.267-.348.544-.524.817C396.513,249.039,396.707,249.34,396.893,249.638Zm-1.511.549c-.18.281-.359.562-.542.842.2.306.389.6.579.9.18-.283.362-.568.548-.85C395.774,250.786,395.58,250.484,395.382,250.187Zm-.722,1.123c-.194.3-.382.592-.57.889.188.309.383.607.576.9.187-.3.381-.594.575-.9Zm.6,3.262c-.2-.305-.393-.615-.594-.926-.181.279-.356.549-.522.813.2.318.4.631.593.927C394.9,255.129,395.086,254.857,395.261,254.572Zm.758-1.164c-.2-.313-.4-.624-.6-.936-.2.309-.382.6-.579.9.2.312.4.626.6.927C395.631,254.005,395.82,253.708,396.019,253.407Zm.718-1.128c-.2-.3-.394-.614-.6-.927-.189.289-.368.572-.552.847.212.315.4.622.6.927C396.371,252.85,396.55,252.568,396.738,252.279Zm.759-1.173c-.2-.3-.4-.614-.6-.919-.2.3-.38.6-.576.9.2.313.4.618.6.927C397.1,251.709,397.3,251.412,397.5,251.106Zm.7-1.088c-.2-.305-.4-.61-.594-.918-.181.266-.355.538-.534.811.208.308.4.622.6.925C397.845,250.571,398.014,250.3,398.194,250.018Zm.176-.269c.187-.3.38-.6.576-.895-.2-.311-.4-.622-.6-.926-.193.3-.388.594-.576.9C397.973,249.132,398.17,249.437,398.37,249.749Zm1.325.269c-.187-.3-.382-.6-.567-.895-.194.3-.388.6-.585.895.2.305.391.6.585.9C399.313,250.621,399.508,250.323,399.7,250.018Zm.824-1.264c-.2-.3-.38-.6-.578-.9-.216.33-.426.664-.647,1,.2.3.391.6.584.895C400.092,249.42,400.3,249.088,400.519,248.755Zm.175-.276.581-.893-.581-.9c-.192.3-.39.6-.576.9C400.3,247.882,400.5,248.182,400.694,248.479Zm1.283.194c-.175-.273-.352-.546-.531-.814-.189.3-.376.591-.572.9.171.268.349.546.524.814C401.586,249.268,401.781,248.971,401.977,248.673Zm.7-1.087c-.174-.271-.348-.544-.526-.811-.171.266-.346.54-.523.811.177.273.352.541.523.814C402.328,248.127,402.5,247.859,402.675,247.586Zm.752,1.168c-.19-.3-.382-.6-.572-.9-.18.268-.349.541-.528.814.192.3.387.594.58.9C403.077,249.3,403.257,249.031,403.427,248.755Zm.179-.276c.2-.3.387-.6.579-.893-.192-.3-.384-.6-.579-.9-.194.3-.386.6-.581.9C403.22,247.882,403.412,248.182,403.606,248.479Zm1.3.226c-.189-.287-.368-.561-.551-.846-.194.3-.382.591-.572.9.186.285.367.566.549.845C404.527,249.3,404.715,249,404.908,248.705Zm.175-.272c.183-.285.363-.562.547-.847-.184-.287-.364-.563-.547-.85-.179.287-.363.563-.543.85C404.719,247.871,404.9,248.148,405.083,248.433Zm1.3.321c-.191-.3-.385-.6-.578-.9-.18.285-.363.559-.544.846.186.3.383.6.567.894Q406.108,249.181,406.387,248.755Zm.172-.276c.194-.3.389-.6.584-.893-.2-.3-.39-.6-.584-.9-.189.3-.382.6-.575.9C406.177,247.882,406.366,248.182,406.559,248.479Zm1.28.194c-.172-.273-.346-.546-.524-.814-.185.3-.378.591-.572.9.174.276.346.546.516.814C407.453,249.268,407.649,248.971,407.839,248.673Zm.179-.273c.174-.273.354-.541.522-.814-.168-.271-.349-.544-.518-.811-.183.266-.348.54-.529.811C407.674,247.859,407.839,248.127,408.018,248.4Zm1.279.354c-.194-.3-.381-.594-.575-.9-.176.268-.35.541-.531.814.194.3.389.594.581.9C408.942,249.3,409.123,249.023,409.3,248.755Zm.177-.276c.191-.3.389-.6.581-.893-.191-.3-.389-.6-.581-.9-.2.3-.38.6-.578.9C409.094,247.882,409.279,248.19,409.475,248.479Zm.757-1.164c.2-.311.4-.616.6-.923-.193-.3-.381-.6-.579-.889-.193.3-.4.606-.592.919C409.848,246.719,410.036,247.015,410.231,247.315Zm.641,1.54c-.224-.331-.427-.665-.641-1-.2.3-.384.591-.576.9.208.333.427.666.631.995C410.484,249.452,410.675,249.151,410.873,248.855Zm.166-.277c.207-.306.4-.618.6-.922-.215-.331-.426-.658-.643-.991-.194.307-.392.61-.6.922C410.619,247.915,410.834,248.252,411.038,248.577Zm.778-1.192c.194-.305.389-.6.582-.893-.218-.339-.427-.669-.639-.99-.189.289-.383.59-.576.889C411.388,246.719,411.608,247.05,411.816,247.385Zm.582,1.439c-.193-.3-.389-.6-.582-.9-.194.3-.393.615-.595.926.194.3.386.6.583.895C412,249.437,412.193,249.132,412.4,248.824Zm.167-.275.585-.893c-.194-.3-.39-.592-.576-.891-.187.291-.381.594-.575.891C412.193,247.953,412.379,248.252,412.566,248.549Zm.765-1.164c.171-.276.353-.546.519-.818-.2-.3-.382-.6-.576-.891-.175.269-.345.539-.525.816Zm.519,1.36c-.166-.273-.349-.549-.524-.817-.189.3-.382.594-.576.9q.263.406.525.813C413.468,249.34,413.655,249.039,413.85,248.746Zm.183-.273c.167-.278.349-.544.517-.817-.168-.271-.35-.546-.517-.817-.178.271-.349.546-.531.817C413.684,247.929,413.85,248.2,414.033,248.473Zm.7-1.087q.292-.458.583-.893c-.181-.271-.354-.547-.529-.816q-.285.443-.581.891C414.382,246.839,414.557,247.11,414.73,247.385Zm.577,1.439c-.189-.3-.383-.6-.577-.9-.173.267-.348.544-.526.817.2.294.382.594.581.892C414.959,249.365,415.132,249.095,415.307,248.824Zm.175-.275c.194-.3.387-.6.582-.893-.2-.3-.389-.592-.582-.891-.189.291-.383.594-.568.891C415.1,247.953,415.293,248.252,415.482,248.549Zm.76-1.164c.185-.283.367-.57.547-.85q-.289-.448-.584-.893c-.18.279-.363.564-.543.85C415.857,246.791,416.052,247.088,416.242,247.385Zm.547,1.393c-.18-.285-.362-.564-.547-.85-.19.3-.385.594-.58.9.18.283.362.564.543.849C416.4,249.372,416.6,249.075,416.789,248.778Zm.169-.274c.191-.285.368-.57.55-.849-.182-.279-.359-.562-.544-.845-.18.277-.367.56-.55.845C416.6,247.944,416.783,248.22,416.958,248.5Zm2.186-2.823c-.172.264-.349.54-.529.811q.29.448.585.893c.171-.276.345-.546.522-.818C419.527,246.269,419.341,245.972,419.144,245.681Zm.753.616c.194-.3.389-.594.581-.886-.193-.308-.387-.6-.581-.9-.182.291-.375.6-.569.9C419.516,245.7,419.7,246,419.9,246.3Zm-.931-.886c-.181-.285-.363-.573-.544-.849-.17.265-.352.534-.525.811.181.276.363.56.552.847C418.62,245.94,418.794,245.676,418.965,245.412Zm-1.242.231c-.2.3-.389.594-.584.893.18.283.362.567.544.85.2-.3.387-.6.584-.893C418.085,246.207,417.9,245.927,417.723,245.643Zm.544,3.187c-.2-.3-.389-.6-.584-.9-.181.285-.363.564-.544.85.2.3.387.594.578.895C417.9,249.388,418.085,249.107,418.266,248.83Zm.174-.281c.194-.3.384-.6.576-.893l-.576-.891c-.189.3-.382.594-.577.891C418.058,247.953,418.252,248.259,418.44,248.549Zm1.274.2c-.169-.273-.348-.549-.514-.817-.2.3-.392.594-.585.9.176.27.35.542.523.808C419.332,249.34,419.522,249.039,419.715,248.746Zm.707-1.09c-.175-.271-.348-.538-.525-.806-.174.26-.351.535-.526.806.175.273.352.54.526.817C420.074,248.2,420.247,247.929,420.421,247.656Zm.759-1.164c-.178-.271-.351-.547-.525-.811-.191.29-.384.588-.578.886.169.271.349.542.518.818C420.791,247.088,420.983,246.783,421.181,246.492Zm.191-1.926c-.171.272-.355.555-.542.845.173.265.351.534.524.809.186-.287.371-.572.549-.841C421.724,245.1,421.555,244.836,421.372,244.566Zm-.567-1.441c.194.3.381.6.576.893.175-.271.355-.544.523-.813-.194-.289-.389-.595-.569-.883C421.163,242.579,420.983,242.847,420.8,243.125Zm-.185.28c-.174.271-.353.549-.542.832.194.3.387.6.578.9.188-.288.366-.567.548-.84C421.011,244,420.817,243.7,420.62,243.405Zm-1.265-.28c.18.28.36.563.548.84.189-.282.37-.56.553-.833-.189-.285-.368-.568-.553-.85C419.723,242.555,419.54,242.833,419.355,243.125Zm-.175.273c-.189.289-.385.589-.584.887.188.28.369.566.548.848.2-.3.39-.6.585-.888C419.54,243.959,419.361,243.676,419.18,243.4Zm-1.335-.273c.187.292.383.588.576.887q.29-.449.582-.887-.293-.451-.582-.891C418.239,242.523,418.045,242.82,417.845,243.125Zm-.706,1.084c.2.289.387.59.584.887.174-.275.347-.542.522-.8-.2-.305-.386-.6-.575-.894C417.5,243.663,417.319,243.927,417.139,244.209Zm-.175.269c-.189.293-.383.586-.576.9l.576.891c.2-.3.383-.6.576-.891C417.346,245.072,417.159,244.776,416.963,244.478Zm-1.275-.193c.169.269.35.542.517.811.2-.3.391-.6.584-.887q-.262-.415-.522-.811C416.077,243.688,415.882,243.987,415.688,244.286Zm-.18.277c-.182.276-.362.558-.546.843.17.271.351.534.52.809.189-.288.376-.566.552-.841C415.857,245.1,415.68,244.828,415.508,244.563Zm-1.3-.326c.2.3.382.6.581.9.185-.288.368-.571.548-.848-.194-.3-.382-.6-.576-.887C414.574,243.667,414.4,243.954,414.2,244.237Zm-.171.271c-.2.291-.383.588-.585.9q.291.445.585.891c.194-.3.388-.594.572-.891C414.414,245.1,414.226,244.808,414.033,244.509Zm-1.4-.367c.221.329.428.658.645.992l.572-.9c-.208-.329-.426-.658-.634-.983C413.028,243.544,412.834,243.836,412.632,244.141Zm-.169.273c-.18.262-.349.535-.531.814.215.326.427.657.642.986.175-.276.351-.544.526-.809C412.877,245.072,412.674,244.744,412.463,244.414Zm-1.28-.352c.194.292.381.59.576.9.172-.281.354-.552.524-.817-.2-.3-.391-.6-.577-.887C411.532,243.515,411.362,243.788,411.183,244.063Zm-.184.271c-.185.293-.38.59-.575.895.187.289.381.587.575.887.2-.3.389-.6.585-.887C411.388,244.924,411.2,244.627,411,244.334Zm-1.274-.193c.176.273.341.535.522.809.2-.3.389-.6.579-.887-.178-.275-.356-.54-.524-.809Zm-.773,1.2c.171.263.355.534.522.807.2-.311.4-.622.592-.92-.165-.271-.348-.544-.515-.814C409.351,244.715,409.151,245.02,408.952,245.342Zm-.179.269c-.193.291-.387.588-.576.887l.526.817c.193-.3.389-.6.575-.893C409.123,246.149,408.95,245.876,408.773,245.611Zm-1.336-.269c.2.289.39.585.585.883.2-.3.387-.594.571-.883-.189-.305-.381-.6-.571-.9Zm-.171.269c-.178.265-.35.538-.524.811.194.3.387.594.572.893.178-.273.352-.544.524-.817C407.649,246.2,407.453,245.9,407.267,245.611Zm-1.25-.309c.18.276.364.562.543.847.184-.273.358-.544.53-.807-.18-.289-.366-.571-.549-.849C406.366,244.756,406.2,245.029,406.017,245.3Zm-.184.271q-.277.446-.567.9c.18.283.364.558.544.847.193-.3.387-.6.578-.893C406.2,246.136,406.017,245.856,405.833,245.572Zm-1.325-.271c.189.3.381.594.575.891.2-.3.388-.6.585-.891-.2-.3-.389-.594-.585-.9C404.9,244.707,404.7,245,404.508,245.3Zm-.175.271c-.182.284-.362.564-.549.849.19.3.378.594.572.893.183-.289.372-.564.551-.847C404.715,246.168,404.52,245.87,404.333,245.572Zm-1.256-.23c.18.263.35.534.529.807.183-.285.365-.571.545-.847-.176-.273-.35-.546-.517-.809C403.452,244.771,403.263,245.052,403.077,245.342Zm-.749,1.156c.174.273.348.544.528.817.2-.3.381-.6.572-.893-.17-.273-.35-.546-.52-.811C402.715,245.9,402.519,246.2,402.328,246.5Zm-.752-1.156c.184.289.383.585.573.883q.284-.446.581-.891-.3-.445-.581-.9C401.963,244.739,401.767,245.037,401.576,245.342Zm-.7,1.08c.189.3.382.594.572.893.18-.273.357-.544.531-.817-.2-.3-.391-.6-.585-.887C401.224,245.876,401.045,246.149,400.874,246.422Zm-.774-1.193c.193.3.392.609.594.92.175-.273.351-.544.524-.807-.2-.321-.393-.626-.594-.927C400.446,244.685,400.279,244.95,400.1,245.229Zm-.751,1.16c.19.31.388.615.592.926.2-.3.383-.6.578-.893-.2-.313-.4-.622-.6-.919C399.731,245.791,399.54,246.092,399.349,246.389Zm-.825,1.267c.2.3.4.616.6.922.206-.331.425-.663.635-.991-.194-.312-.394-.615-.6-.922C398.96,247,398.74,247.325,398.524,247.656Zm-.75-1.17c.188.3.383.594.576.9.213-.335.429-.667.641-1l-.576-.886C398.2,245.823,397.987,246.153,397.774,246.486Zm-.174.28c-.194.3-.389.594-.584.891l.584.893c.187-.3.38-.6.57-.893C397.981,247.359,397.787,247.064,397.6,246.765Zm-1.282-.2c.176.271.348.542.524.818.2-.3.381-.6.577-.9-.174-.271-.353-.54-.526-.809C396.707,245.972,396.513,246.269,396.318,246.568Zm-.7,1.088c.17.273.349.539.519.809.181-.271.349-.536.53-.809-.18-.271-.348-.546-.53-.817C395.967,247.11,395.787,247.385,395.618,247.656Zm-.179.273c-.2.3-.383.594-.581.9.179.271.354.541.524.813.2-.3.392-.6.585-.892C395.787,248.473,395.618,248.2,395.439,247.929Zm-.752.62c.191-.3.381-.6.574-.893-.193-.3-.388-.592-.574-.891-.194.3-.39.594-.584.891C394.3,247.953,394.493,248.252,394.687,248.549Zm-.543,1.394c.166.273.348.541.522.818.174-.285.357-.566.546-.85-.176-.273-.354-.545-.526-.811C394.5,249.378,394.324,249.666,394.144,249.943Zm-.76,1.172c.177.273.351.544.524.818.2-.3.38-.6.585-.9-.182-.268-.348-.545-.531-.81C393.765,250.516,393.574,250.818,393.384,251.115Zm-.173,1.9c.166-.268.35-.536.524-.821-.174-.266-.351-.54-.524-.811-.184.271-.353.544-.532.811C392.858,252.472,393.035,252.745,393.211,253.019Zm0,2.341c.185-.291.373-.589.582-.9-.194-.294-.389-.59-.582-.9-.2.309-.39.608-.585.9C392.83,254.764,393.014,255.063,393.211,255.36Z",
    transform: "translate(-391.616 -241.843)",
    fill: "#949494",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_681",
    "data-name": "Group 681",
    transform: "translate(48.799 25.388)"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_680",
    "data-name": "Group 680",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13319",
    "data-name": "Path 13319",
    d: "M378.394,243.123h.581s.414.285-.038.681h-.5Z",
    transform: "translate(-376.574 -241.899)",
    fill: "#727271"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_679",
    "data-name": "Group 679"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13320",
    "data-name": "Path 13320",
    d: "M379.061,241.63a.6.6,0,0,0-.157.014v3.107a1.278,1.278,0,0,0,.157.011c.7,0,1.077-.59,1.27-1.261v-.608A1.268,1.268,0,0,0,379.061,241.63Z",
    transform: "translate(-378.176 -241.63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13321",
    "data-name": "Path 13321",
    d: "M381.372,241.647s-.728.222-.728,1.551c-.007,1.464.728,1.556.728,1.556Z",
    transform: "translate(-380.644 -241.633)",
    fill: "#ed3a0f"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13322",
    "data-name": "Path 13322",
    d: "M381.269,241.918a2.316,2.316,0,0,0-.458,1.716s.089-.728.458-.969Z",
    transform: "translate(-380.676 -241.682)",
    fill: "#4A4A4A",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_684",
    "data-name": "Group 684",
    transform: "translate(82.163 1.486)"
  }, _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_683",
    "data-name": "Group 683",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13323",
    "data-name": "Path 13323",
    d: "M340.678,213.972H340.1s-.422.285.03.679h.5Z",
    transform: "translate(-339.924 -212.749)",
    fill: "#727271"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    "data-name": "Group 682",
    transform: "translate(0.424)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13324",
    "data-name": "Path 13324",
    d: "M339.854,212.481a1.257,1.257,0,0,1,.161.007V215.6c-.051,0-.1,0-.161,0-.692,0-1.067-.59-1.263-1.264v-.606A1.261,1.261,0,0,1,339.854,212.481Z",
    transform: "translate(-338.591 -212.481)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13325",
    "data-name": "Path 13325",
    d: "M337.7,212.489s.726.224.731,1.556c0,1.459-.731,1.56-.731,1.56Z",
    transform: "translate(-336.276 -212.482)",
    fill: "#ed3a0f"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13326",
    "data-name": "Path 13326",
    d: "M337.857,212.762a2.335,2.335,0,0,1,.467,1.721s-.093-.729-.467-.97Z",
    transform: "translate(-335.879 -212.532)",
    fill: "#4A4A4A",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_688",
    "data-name": "Group 688",
    transform: "translate(61.08 21.467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_687",
    "data-name": "Group 687",
    transform: "translate(0)"
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13327",
    "data-name": "Path 13327",
    d: "M339.246,257.88l-4.084,4.4h4.667Z",
    transform: "translate(-314.088 -240.634)",
    fill: "#F26A1B"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13328",
    "data-name": "Path 13328",
    d: "M341.469,239.274l.566,2.675-.286.413-.619-2.648Z",
    transform: "translate(-321.186 -237.285)",
    fill: "#2b2b2b"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13329",
    "data-name": "Path 13329",
    d: "M342.187,244.492l2.718-.345.3-.4-2.708.278Z",
    transform: "translate(-325.225 -238.09)",
    fill: "#2b2b2b"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13330",
    "data-name": "Path 13330",
    d: "M358.232,262.127H334.84v3.413h21.548Z",
    transform: "translate(-332.226 -241.399)",
    fill: "#23211f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13331",
    "data-name": "Path 13331",
    d: "M358.232,264.142H334.84v1.76h21.548Z",
    transform: "translate(-332.226 -241.762)",
    fill: "#696969",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13332",
    "data-name": "Path 13332",
    d: "M342.993,244.507l-4.459-3.327-1.019,1.272,3.936,4.017Z",
    transform: "translate(-319.181 -237.628)",
    fill: "#525252"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13333",
    "data-name": "Path 13333",
    d: "M343.2,245.837l-.6.756-3.936-4.016.564-.7C340.014,242.637,342.656,245.278,343.2,245.837Z",
    transform: "translate(-320.334 -237.753)",
    fill: "#525252",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13334",
    "data-name": "Path 13334",
    d: "M342.962,242.787l-.33-.335,1.019-1.272.263.2C343.61,241.86,343.292,242.324,342.962,242.787Z",
    transform: "translate(-324.298 -237.628)",
    fill: "#525252",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13335",
    "data-name": "Path 13335",
    d: "M338.855,243.539l1.873,1.393-1.542,1.961-1.67-1.707C337.97,244.648,338.422,244.093,338.855,243.539Z",
    transform: "translate(-316.915 -238.053)",
    fill: "#525252",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13336",
    "data-name": "Path 13336",
    d: "M340.939,242.76l-1.055-.56-2.959,3.772.693,1.219Z",
    transform: "translate(-316.642 -237.812)",
    fill: "#F26A1B"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13337",
    "data-name": "Path 13337",
    d: "M341.5,242.7c-.389.51-.481,1.094-.208,1.293h0c.278.209.809-.044,1.192-.558l3.043-4.088c.389-.513.473-1.1.2-1.3h0c-.271-.207-.8.046-1.183.556Z",
    transform: "translate(-325.042 -237.052)",
    fill: "#F26A1B"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13338",
    "data-name": "Path 13338",
    d: "M337.547,245.085l-.674-3.132-3,.2-3.472,4.493s-.3.259,0,.977,4.649,12.263,4.649,12.263l4.4-2.371Z",
    transform: "translate(-309.696 -237.767)",
    fill: "#914a17"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13339",
    "data-name": "Path 13339",
    d: "M333.48,245.085l-.674-3.132-2.019.134,3.018,13.527s-3.638,2.092-3.535,2.389c.28.722.711,1.885.711,1.885l4.4-2.371Z",
    transform: "translate(-305.629 -237.767)",
    fill: "#914a17",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13340",
    "data-name": "Path 13340",
    d: "M345.82,252.636s10.022.758,14.274,1.455a2.5,2.5,0,0,1,1.783,2.156c.376,1.9.945,8.313.945,8.313H350.958Z",
    transform: "translate(-345.82 -239.69)",
    fill: "#363432"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13341",
    "data-name": "Path 13341",
    d: "M349.066,258.337l-2.461-5.7s10.022.758,14.274,1.455a2.5,2.5,0,0,1,1.783,2.156c.089.473.193,1.232.3,2.09Z",
    transform: "translate(-346.605 -239.69)",
    fill: "#5c5c5c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13342",
    "data-name": "Path 13342",
    d: "M347.039,253.865s5.808.432,9.511,1.033a2.152,2.152,0,0,1,1.54,1.875c.337,1.656.738,6.239.738,6.239h-7.9l-.847-6.44-2.947-2.093Z",
    transform: "translate(-342.825 -239.912)",
    fill: "#696969",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_685",
    "data-name": "Group 685",
    transform: "translate(4.214 13.953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13343",
    "data-name": "Path 13343",
    d: "M356.383,255.275c-3.264-.534-8.173-.927-9.284-1.01l-.06-.4s5.808.432,9.511,1.033a2.152,2.152,0,0,1,1.54,1.875c.337,1.656.738,6.239.738,6.239h-.2c-.113-1.124-.437-4.491-.707-5.864A2.164,2.164,0,0,0,356.383,255.275Z",
    transform: "translate(-347.039 -253.865)",
    fill: "#696969",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13344",
    "data-name": "Path 13344",
    d: "M342.293,243.367l-2.516-1.913-.111.138,2.357,2.118Z",
    transform: "translate(-320.244 -237.677)",
    fill: "#525252",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686",
    transform: "translate(1.712)"
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13345",
    "data-name": "Path 13345",
    d: "M357.736,248.563s3.232.211,3.363,1.437-1.114,1.412-2.427,1.347l-10.121-1.187a1.191,1.191,0,0,1-.922-.795c-.249-.721-1.475-7.329-1.819-10.612,0,0-.083-1.865,1.056-1.9a2.711,2.711,0,0,1,2.669,1.987c.421,1.312,1.23,8.166-.085,9.684,0,0,.7-.528,3.341-.381C354.688,248.246,357.736,248.563,357.736,248.563Z",
    transform: "translate(-345.809 -236.848)",
    fill: "#303030"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13346",
    "data-name": "Path 13346",
    d: "M347.036,236.851a2.6,2.6,0,0,1,1.36.33c-.025,0-.063-.007-.088-.007-.559-.018-1.3.334-1.282.977a4.712,4.712,0,0,0,.33,1.317,12.232,12.232,0,0,1,.486,1.838,30.649,30.649,0,0,1,.288,3.98c.016.631-.037,1.413.5,1.851a1.068,1.068,0,0,0,1.364-.267,2.039,2.039,0,0,0,.273-.444,4.145,4.145,0,0,1-.642,2.1,3.42,3.42,0,0,1,1.676-.381c.273.514.39,1.1.986,1.371a10.273,10.273,0,0,0,2.5.48c1.181.177,2.357.339,3.551.49.931.125,1.869.169,2.808.241-.349.578-1.308.679-2.3.626l-10.121-1.187a1.191,1.191,0,0,1-.922-.795c-.249-.721-1.475-7.329-1.819-10.611C345.98,238.756,345.9,236.891,347.036,236.851Z",
    transform: "translate(-345.979 -236.849)",
    fill: "#F26A1B"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13347",
    "data-name": "Path 13347",
    d: "M358.012,252.369s1.3-2.322,3.161-2.366,1.056,2.808,1.056,2.808Z",
    transform: "translate(-357.11 -239.216)",
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13348",
    "data-name": "Path 13348",
    d: "M359.4,237.4s.963.093,1.49,2.178.645,6.518.348,7.084C361.234,246.664,361.078,239.545,359.4,237.4Z",
    transform: "translate(-357.237 -236.948)",
    fill: "#303030",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13349",
    "data-name": "Path 13349",
    d: "M359.4,251.726a.559.559,0,1,0,1.118,0,.559.559,0,1,0-1.118,0Z",
    transform: "translate(-356.358 -239.424)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13350",
    "data-name": "Path 13350",
    d: "M359.709,251.783a.294.294,0,0,0,.3.3.3.3,0,0,0,.306-.3.306.306,0,0,0-.306-.307A.3.3,0,0,0,359.709,251.783Z",
    transform: "translate(-356.411 -239.482)",
    fill: "#262626"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13351",
    "data-name": "Path 13351",
    d: "M354.933,252.772s.18-1.187-3.068-1.592c0,0-5.349-.526-5.888-.449,0,0,6.055.558,7.221.918A3.632,3.632,0,0,1,354.933,252.772Z",
    transform: "translate(-339.773 -239.346)",
    fill: "#303030",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })))), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13352",
    "data-name": "Path 13352",
    d: "M416.486,273.879h-110.2c-1.665,0-1.574-3.549-1.574-3.549a3.5,3.5,0,0,0,1.415-2.148,5.612,5.612,0,0,0,.061-2.128c0-.482-1.567.152-1.567-.3a27.57,27.57,0,0,1,.091-2.807c.194-1.479,2.655-1.18,2.655-1.18H350.2s9.752-45.6,10.639-48.353,4.332-2.369,4.332-2.369h20.581a1.7,1.7,0,0,1,1.774,1.087,24.072,24.072,0,0,1,.59,2.955c.1,1.08-.59.98-.59.98H386.35l2.849,15.86h14.477a6.708,6.708,0,0,1,6.652,5.462Zm-53.288-39.4h10.866c-.272-8.229-.519-16-.519-16s-.218-2.356-1.774-2.356h-4.208a2.057,2.057,0,0,0-1.917,1.617Zm11.527,19.013c-.072-1.09-.337-9.054-.605-17.108h-11.2l-2.37,16.219s-.523,2.734,1.471,2.878h10.636A1.753,1.753,0,0,0,374.725,253.494Zm15.142-13.74c-.291-1.626-3.988-22.455-3.988-22.455a1.6,1.6,0,0,0-1.695-1.164c-1.406.057-2.363.032-2.363.032H376.8s-1.968-.389-2.072,1.379.93,22.356.93,22.356.054,1.474,1.038,1.574h11.625S390.163,241.376,389.867,239.754Z",
    transform: "translate(-304.619 -210.733)",
    fill: "#4A4A4A"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13353",
    "data-name": "Path 13353",
    d: "M412.042,255.584c-20-.025-25.768,19.21-25.768,19.21H356.8a37.721,37.721,0,0,0-5.229-11.391c-.831,3.876-1.368,6.385-1.368,6.385H307.365s-2.462-.3-2.655,1.18a27.569,27.569,0,0,0-.091,2.807c0,.453,1.567-.181,1.567.3a5.612,5.612,0,0,1-.061,2.128,3.5,3.5,0,0,1-1.415,2.148s-.091,3.549,1.574,3.549h110.2Z",
    transform: "translate(-304.619 -218.754)",
    fill: "#ca7123"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13354",
    "data-name": "Path 13354",
    d: "M416.791,277.239l-.317-1.87H306.345c-.02.506-.033,1.159-.033,1.87Z",
    transform: "translate(-306.312 -222.316)",
    fill: "#F26A1B"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13355",
    "data-name": "Path 13355",
    d: "M370.88,269.268l-.353-2.071H308.089c-.166.777-.312,1.469-.439,2.071Z",
    transform: "translate(-261.499 -220.845)",
    fill: "#F26A1B"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13356",
    "data-name": "Path 13356",
    d: "M305.993,280.887a3.447,3.447,0,0,1-1.373,2.019s-.091,3.549,1.574,3.549H416.4l-.942-5.568Z",
    transform: "translate(-304.529 -223.309)",
    fill: "#F26A1B"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_689",
    "data-name": "Group 689",
    transform: "translate(53.936 3.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13357",
    "data-name": "Path 13357",
    d: "M367.755,255.12c.117,1.7-1.774,2.136-1.774,2.136H335.746c-2.8-.14-2.11-3.009-2.11-3.009s5.659-36.243,5.984-37.519,2.685-1.187,2.685-1.187h16.786a2.454,2.454,0,0,1,2.371,1.476Zm-29.55-19.826h10.866c-.272-8.229-.519-16-.519-16s-.218-2.356-1.774-2.356H342.57a2.057,2.057,0,0,0-1.917,1.617Zm11.527,19.013c-.072-1.09-.337-9.054-.605-17.108h-11.2l-2.37,16.219s-.523,2.734,1.471,2.878h10.636A1.753,1.753,0,0,0,349.732,254.306Zm15.142-13.74c-.291-1.626-3.988-22.455-3.988-22.455a1.6,1.6,0,0,0-1.695-1.164c-1.406.057-2.363.032-2.363.032H351.8s-1.968-.389-2.072,1.379.93,22.356.93,22.356.054,1.474,1.038,1.574h11.625S365.17,242.189,364.874,240.567Z",
    transform: "translate(-333.562 -215.539)",
    fill: "#4A4A4A"
  }))), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13358",
    "data-name": "Path 13358",
    d: "M361.517,211.475h-7.931a3.317,3.317,0,0,0-3.154,2.708c-.79,2.81-9.257,43.185-9.257,43.185l11.769-40.428s.3-2.7,2.708-2.857,18.467,0,18.467,0,1.628-.49,1.771-1.921c0,0,.244-.686-1.178-.686Z",
    transform: "translate(-294.016 -210.814)",
    fill: "#4A4A4A"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13359",
    "data-name": "Path 13359",
    d: "M348.2,218.42a1.6,1.6,0,0,0-1.695-1.164c-1.406.057-2.363.032-2.363.032h-5.024s-1.968-.39-2.072,1.379.93,22.356.93,22.356.054,1.474,1.038,1.574h11.625s1.846-.1,1.549-1.722S348.2,218.42,348.2,218.42Z",
    transform: "translate(-266.944 -211.854)",
    fill: "#00a8e3",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13360",
    "data-name": "Path 13360",
    d: "M354.891,217.288h-.942a2.612,2.612,0,0,0-1.176.076c-.274.3-.547.59-.818.879a1.935,1.935,0,0,0-.079.424c-.012.235,0,.769.012,1.54Q353.378,218.734,354.891,217.288Z",
    transform: "translate(-281.771 -211.854)",
    fill: "#9be9e3",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13361",
    "data-name": "Path 13361",
    d: "M339.827,242.485c2.629-2.513,5.333-4.94,8.027-7.373q2.118-1.915,4.233-3.822c-.485-2.751-.981-5.54-1.364-7.712-3.8,3.574-7.587,7.163-11.309,10.82.193,4.248.373,7.764.373,7.764A3.157,3.157,0,0,0,339.827,242.485Z",
    transform: "translate(-268.751 -212.993)",
    fill: "#9be9e3",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13362",
    "data-name": "Path 13362",
    d: "M366.7,219.6s-.218-2.356-1.774-2.356h-4.208a2.057,2.057,0,0,0-1.917,1.617L356.354,235.6H367.22C366.947,227.372,366.7,219.6,366.7,219.6Z",
    transform: "translate(-297.775 -211.853)",
    fill: "#00a8e3",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13363",
    "data-name": "Path 13363",
    d: "M356.354,239.387h1.151c-.014-.368-.027-.733-.039-1.106C357.09,238.654,356.727,239.019,356.354,239.387Z",
    transform: "translate(-288.06 -215.639)",
    fill: "#9be9e3",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13364",
    "data-name": "Path 13364",
    d: "M366.738,221.865c-.033-1.106-.052-1.747-.052-1.747v-.011c-1.345,1.429-2.691,2.854-4.033,4.292-1.846,1.983-3.671,3.972-5.479,6l-.251,1.706Q361.779,226.93,366.738,221.865Z",
    transform: "translate(-297.76 -212.368)",
    fill: "#9be9e3",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13365",
    "data-name": "Path 13365",
    d: "M369.17,241.953h-11.2l-2.37,16.219s-.523,2.734,1.471,2.878h10.636a1.753,1.753,0,0,0,2.066-1.989C369.7,257.971,369.439,250.007,369.17,241.953Z",
    transform: "translate(-299.67 -216.3)",
    fill: "#00a8e3",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13366",
    "data-name": "Path 13366",
    d: "M359.464,257.662c3.237-3.148,6.325-6.431,9.51-9.623.294-.289.6-.588.9-.881-.064-1.683-.119-3.443-.176-5.205h-3.093q-4.729,4.791-9.323,9.707c-.082.084-.162.165-.241.259l-.911,6.253a3.485,3.485,0,0,0,.349,2.3C357.489,259.552,358.487,258.61,359.464,257.662Z",
    transform: "translate(-300.198 -216.3)",
    fill: "#9be9e3",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13367",
    "data-name": "Path 13367",
    d: "M346.605,217.846h-.078c-.8.03-1.452.036-1.864.036h-5.6l-.06-.011h0a2.192,2.192,0,0,0-.336-.025c-.977,0-1.009.6-1.023.85-.076,1.38.571,15.192.932,22.3,0,.012.067.937.479,1.012h11.564a1.44,1.44,0,0,0,.893-.39.761.761,0,0,0,.1-.635c-.289-1.587-3.845-21.613-3.988-22.437a.993.993,0,0,0-1.023-.7Zm0-.6a1.6,1.6,0,0,1,1.6,1.172s3.7,20.829,3.988,22.455-1.549,1.722-1.549,1.722H339.017c-.984-.1-1.038-1.574-1.038-1.574s-1.028-20.583-.93-22.356a1.437,1.437,0,0,1,1.618-1.411,3.018,3.018,0,0,1,.454.032h5.024s.189.008.518.008c.412,0,1.059-.008,1.845-.04a.424.424,0,0,1,.1-.007Z",
    transform: "translate(-266.944 -211.853)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13368",
    "data-name": "Path 13368",
    d: "M364.927,217.846h-4.193a1.432,1.432,0,0,0-1.355,1.118l-2.338,16.048h9.564c-.253-7.744-.48-14.915-.492-15.368a3.945,3.945,0,0,0-.267-1.009c-.349-.789-.778-.789-.92-.789Zm0-.6c1.556,0,1.774,2.356,1.774,2.356s.247,7.769.519,16H356.354l2.448-16.736a2.057,2.057,0,0,1,1.917-1.617Z",
    transform: "translate(-297.775 -211.853)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13369",
    "data-name": "Path 13369",
    d: "M368.6,242.543H358.484l-2.292,15.714-.006.008-.007.016a2.759,2.759,0,0,0,.257,1.851.86.86,0,0,0,.662.333h10.649l.041.006h0s.063.007.161.007a1.367,1.367,0,0,0,.973-.335,1.4,1.4,0,0,0,.257-1.044c-.051-.9-.248-6.466-.584-16.556Zm.575-.59c.268,8.054.533,16.018.605,17.108a1.694,1.694,0,0,1-1.827,2.006,1.614,1.614,0,0,1-.239-.016H357.073c-1.994-.144-1.471-2.878-1.471-2.878l2.37-16.219Z",
    transform: "translate(-299.67 -216.3)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13370",
    "data-name": "Path 13370",
    d: "M370.738,267.513a1.218,1.218,0,0,1-1.218,1.219H337.1a1.224,1.224,0,0,1-1.225-1.219h0a1.223,1.223,0,0,1,1.225-1.224h32.421a1.217,1.217,0,0,1,1.218,1.224Z",
    transform: "translate(-284.5 -220.681)",
    fill: "#4A4A4A"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13371",
    "data-name": "Path 13371",
    d: "M370.738,268.035c0,.48-.544.857-1.218.857H337.1c-.674,0-1.225-.377-1.225-.857h0c0-.474.551-.857,1.225-.857h32.421c.674,0,1.218.383,1.218.857Z",
    transform: "translate(-284.5 -220.841)",
    fill: "#4A4A4A"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13372",
    "data-name": "Path 13372",
    d: "M344.058,214.274a3.12,3.12,0,0,1,3.173-2.4h19.061s.92.039.362.333-19.165.391-19.165.391a2.835,2.835,0,0,0-2.361,1.332s-.41.795-.966.786C343.93,214.721,344.058,214.274,344.058,214.274Z",
    transform: "translate(-287.278 -210.887)",
    fill: "#fff"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13373",
    "data-name": "Path 13373",
    d: "M312.836,239.143l3.692,18.215s6.965-6.17,15.2-5.691l-1.306-8.758s-2-4.649-6.927-4.352S312.836,239.143,312.836,239.143Z",
    transform: "translate(-226.598 -215.687)",
    fill: "#e87221"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13374",
    "data-name": "Path 13374",
    d: "M313.33,239.682l3.379,17.052a23.921,23.921,0,0,1,14.523-5.462l-1.223-7.833s-1.878-4.7-6.8-4.408S313.33,239.682,313.33,239.682Z",
    transform: "translate(-226.508 -215.772)",
    fill: "#4A4A4A"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13375",
    "data-name": "Path 13375",
    d: "M312.836,237.037l13.261.016a6.6,6.6,0,0,1,6.587,4.906s-2.33-4.34-6.364-4.354-13.388.205-13.388.205Z",
    transform: "translate(-227.555 -215.416)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_691",
    "data-name": "Group 691",
    transform: "translate(54.309 47.111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13376",
    "data-name": "Path 13376",
    d: "M354.414,284.215V269.268H355.9v2.14h12.959v-2.14h1.478v14.947h-1.478v-2.967H355.9v2.967Zm1.483-4.762h12.959V273.2H355.9Z",
    transform: "translate(-353.607 -268.328)",
    fill: "#4A4A4A",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_690",
    "data-name": "Group 690",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_448",
    "data-name": "Rectangle 448",
    width: 15.921,
    height: 1.84,
    transform: "translate(0.806 2.186)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_449",
    "data-name": "Rectangle 449",
    width: 13.957,
    height: 0.31,
    transform: "translate(1.839 2.445)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_450",
    "data-name": "Rectangle 450",
    width: 15.921,
    height: 1.837,
    transform: "translate(0.806 10.438)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_451",
    "data-name": "Rectangle 451",
    width: 15.921,
    height: 1.839,
    transform: "translate(0.806 18.689)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_452",
    "data-name": "Rectangle 452",
    width: 1.623,
    height: 22.776,
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_453",
    "data-name": "Rectangle 453",
    width: 1.629,
    height: 22.776,
    transform: "translate(15.914)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_454",
    "data-name": "Rectangle 454",
    width: 13.957,
    height: 0.313,
    transform: "translate(1.839 10.716)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_455",
    "data-name": "Rectangle 455",
    width: 13.957,
    height: 0.31,
    transform: "translate(1.839 19.162)",
    fill: "#bdbdbd"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_456",
    "data-name": "Rectangle 456",
    width: 0.542,
    height: 22.157,
    transform: "translate(0.387 0.275)",
    fill: "#bdbdbd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_457",
    "data-name": "Rectangle 457",
    width: 0.542,
    height: 22.157,
    transform: "translate(16.185 0.275)",
    fill: "#bdbdbd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13377",
    "data-name": "Path 13377",
    d: "M396.575,257.514a32.316,32.316,0,0,1,3.133-3.855,4.542,4.542,0,0,1,2.693-1.241c1.567-.084,17.921-.81,17.921-.81l-17.039,1.244a6.425,6.425,0,0,0-2.986.916A40.507,40.507,0,0,0,396.575,257.514Z",
    transform: "translate(-383.858 -218.038)",
    fill: "#4A4A4A",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13378",
    "data-name": "Path 13378",
    d: "M392.132,257.766l2.5-9.157s1.208-4.34,4.528-5.46a119.3,119.3,0,0,1,14.42-2.754c8.837-1.193,12.961-1.835,12.961-1.835l-19.233,3.376-7.084,1.438a6.84,6.84,0,0,0-4.014,3.35C394.774,249.793,392.132,257.766,392.132,257.766Z",
    transform: "translate(-386.435 -215.69)",
    fill: "#4A4A4A",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_692",
    "data-name": "Group 692",
    transform: "translate(70.577 31.105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13379",
    "data-name": "Path 13379",
    d: "M335.634,264.328a.625.625,0,0,1-.622.617.617.617,0,0,1-.608-.617.61.61,0,0,1,.608-.612A.618.618,0,0,1,335.634,264.328Z",
    transform: "translate(-318.767 -251.323)",
    fill: "#F26A1B",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13380",
    "data-name": "Path 13380",
    d: "M337.1,256.726a.614.614,0,1,1-1.228,0,.614.614,0,1,1,1.228,0Z",
    transform: "translate(-321.441 -249.954)",
    fill: "#F26A1B",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13381",
    "data-name": "Path 13381",
    d: "M338.493,249.216a.615.615,0,1,1-.612-.614A.612.612,0,0,1,338.493,249.216Z",
    transform: "translate(-323.971 -248.602)",
    fill: "#F26A1B",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13382",
    "data-name": "Path 13382",
    d: "M354.7,264.328a.616.616,0,1,1-1.232,0,.616.616,0,0,1,1.232,0Z",
    transform: "translate(-353.47 -251.323)",
    fill: "#F26A1B",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13383",
    "data-name": "Path 13383",
    d: "M344.675,264.328a.62.62,0,0,1-1.239,0,.62.62,0,0,1,1.239,0Z",
    transform: "translate(-335.215 -251.323)",
    fill: "#F26A1B",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_693",
    "data-name": "Group 693",
    transform: "translate(55.87 5.395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13384",
    "data-name": "Path 13384",
    d: "M357.073,261.051h10.636a1.753,1.753,0,0,0,2.066-1.989c-.072-1.09-.337-9.054-.605-17.108h-11.2l-2.37,16.219S355.079,260.906,357.073,261.051Z",
    transform: "translate(-355.54 -221.695)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13385",
    "data-name": "Path 13385",
    d: "M366.7,219.6s-.218-2.356-1.774-2.356h-4.208a2.057,2.057,0,0,0-1.917,1.617L356.354,235.6H367.22C366.947,227.372,366.7,219.6,366.7,219.6Z",
    transform: "translate(-353.645 -217.248)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13386",
    "data-name": "Path 13386",
    d: "M339.017,242.6h11.625s1.846-.1,1.549-1.722S348.2,218.42,348.2,218.42a1.6,1.6,0,0,0-1.695-1.164c-1.406.057-2.363.032-2.363.032h-5.024s-1.968-.39-2.072,1.379.93,22.356.93,22.356S338.033,242.5,339.017,242.6Z",
    transform: "translate(-322.814 -217.249)",
    fill: "none"
  }))), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13387",
    "data-name": "Path 13387",
    d: "M331.624,236.516,335.9,259.7l.842-.795Z",
    transform: "translate(-247.015 -215.322)",
    fill: "#ca7123"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_712",
    "data-name": "Group 712",
    transform: "translate(1.828 37.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_707",
    "data-name": "Group 707",
    transform: "translate(3.87 3.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_700",
    "data-name": "Group 700",
    transform: "translate(0)"
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13388",
    "data-name": "Path 13388",
    d: "M424.18,281.859a20.569,20.569,0,1,1-20.567-20.571A20.564,20.564,0,0,1,424.18,281.859Z",
    transform: "translate(-382.317 -260.561)",
    fill: "#F26A1B"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13389",
    "data-name": "Path 13389",
    d: "M423.5,281.909v-.959l1.244.208a21.3,21.3,0,0,0-1.423-7.15l-1.363.1-.373-.881,1.283-.3a21.464,21.464,0,0,0-4.055-5.988l-1.254.635-.689-.668,1.1-.8a21.3,21.3,0,0,0-6.178-4.026l-.931,1.112-.895-.353.721-1.187A21.082,21.082,0,0,0,404,260.4l-.458,1.369h-.959l.234-1.363a21.065,21.065,0,0,0-7.173,1.469l.107,1.436-.888.374-.308-1.35a21.4,21.4,0,0,0-5.983,4.119l.641,1.261-.667.676-.8-1.094a21.239,21.239,0,0,0-3.97,6.227l1.05.875-.349.9-1.123-.674a21.337,21.337,0,0,0-1.2,6.7l1.244.422v.955l-1.23-.212a21.109,21.109,0,0,0,1.514,7.14l1.26-.1.372.881-1.178.28a21.664,21.664,0,0,0,4.117,5.931l1.091-.558.685.675-.949.686a21.49,21.49,0,0,0,6.194,3.942l.763-.915.894.349-.589.973a21.342,21.342,0,0,0,6.648,1.212l.378-1.114h.958l-.189,1.1a21.078,21.078,0,0,0,7.115-1.464l-.09-1.184.88-.37.259,1.113a21.346,21.346,0,0,0,5.944-4.06l-.549-1.083.671-.683.679.948a21.052,21.052,0,0,0,4-6.143l-.972-.814.349-.89,1.048.629a21.311,21.311,0,0,0,1.263-6.657Z",
    transform: "translate(-382.158 -260.402)",
    fill: "#F26A1B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_699",
    "data-name": "Group 699",
    transform: "translate(2.502 2.496)"
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13390",
    "data-name": "Path 13390",
    d: "M422.793,282.234A18.794,18.794,0,1,1,404,263.446,18.792,18.792,0,0,1,422.793,282.234Z",
    transform: "translate(-385.205 -263.446)",
    fill: "#F26A1B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_695",
    "data-name": "Group 695",
    transform: "translate(0)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13391",
    "data-name": "Path 13391",
    d: "M421.355,278.125a22.938,22.938,0,0,1,1.01,8.058,18.79,18.79,0,1,0-36.041,2.44c-.035-.143-.073-.281-.111-.434a17.744,17.744,0,0,1-.234-6.1,1.2,1.2,0,0,1,.025-.168,18.026,18.026,0,0,1,35.35-3.794Z",
    transform: "translate(-385.205 -263.446)",
    fill: "#636363",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13392",
    "data-name": "Path 13392",
    d: "M407.922,309.254c-.3.015-.6.02-.922.02C407.318,309.275,407.619,309.269,407.922,309.254Z",
    transform: "translate(-388.206 -271.692)",
    fill: "#1c1c1c"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13393",
    "data-name": "Path 13393",
    d: "M409.051,309.275c-.312,0-.622-.006-.926-.02C408.428,309.269,408.738,309.275,409.051,309.275Z",
    transform: "translate(-390.257 -271.692)",
    fill: "#1c1c1c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13394",
    "data-name": "Path 13394",
    d: "M417.632,283.488a12.18,12.18,0,1,1-12.178-12.178A12.179,12.179,0,0,1,417.632,283.488Z",
    transform: "translate(-386.66 -264.862)",
    fill: "#1c1c1c",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13395",
    "data-name": "Path 13395",
    d: "M416.4,284.03a10.607,10.607,0,1,1-10.61-10.6A10.609,10.609,0,0,1,416.4,284.03Z",
    transform: "translate(-386.997 -265.242)",
    fill: "#ededed",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13396",
    "data-name": "Path 13396",
    d: "M415.942,284.2a10.016,10.016,0,1,1-10.016-10.02A10.016,10.016,0,0,1,415.942,284.2Z",
    transform: "translate(-387.132 -265.379)",
    fill: "#6e460d"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13397",
    "data-name": "Path 13397",
    d: "M414.785,284.737a8.533,8.533,0,1,1-8.533-8.532A8.534,8.534,0,0,1,414.785,284.737Z",
    transform: "translate(-387.458 -265.743)",
    fill: "#4A4A4A"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13398",
    "data-name": "Path 13398",
    d: "M412.485,285.124a5.586,5.586,0,1,1-5.586-5.586A5.586,5.586,0,0,1,412.485,285.124Z",
    transform: "translate(-388.105 -266.343)",
    fill: "#4A4A4A"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_698",
    "data-name": "Group 698",
    transform: "translate(11.109 11.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_696",
    "data-name": "Group 696",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13399",
    "data-name": "Path 13399",
    d: "M408.53,277.517a.538.538,0,1,1-.538-.528A.542.542,0,0,1,408.53,277.517Z",
    transform: "translate(-400.296 -276.989)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13400",
    "data-name": "Path 13400",
    d: "M408.562,294.976a.536.536,0,1,1-.536-.542A.538.538,0,0,1,408.562,294.976Z",
    transform: "translate(-400.355 -280.129)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13401",
    "data-name": "Path 13401",
    d: "M399.282,286.8a.536.536,0,1,1,.534-.538A.532.532,0,0,1,399.282,286.8Z",
    transform: "translate(-384.445 -278.561)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13402",
    "data-name": "Path 13402",
    d: "M416.733,286.767a.536.536,0,1,1,.531-.535A.532.532,0,0,1,416.733,286.767Z",
    transform: "translate(-416.204 -278.556)",
    fill: "#4A4A4A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_697",
    "data-name": "Group 697",
    transform: "translate(2.083 2.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13403",
    "data-name": "Path 13403",
    d: "M402.2,280.463a.528.528,0,0,1-.749,0,.545.545,0,0,1,0-.758.528.528,0,0,1,.749,0A.536.536,0,0,1,402.2,280.463Z",
    transform: "translate(-391.157 -279.537)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13404",
    "data-name": "Path 13404",
    d: "M414.568,292.784a.534.534,0,1,1,0-.758A.537.537,0,0,1,414.568,292.784Z",
    transform: "translate(-413.659 -281.755)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13405",
    "data-name": "Path 13405",
    d: "M401.472,292.8a.524.524,0,0,1,0-.753.533.533,0,0,1,.751,0,.532.532,0,0,1-.751.753Z",
    transform: "translate(-391.198 -281.759)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13406",
    "data-name": "Path 13406",
    d: "M413.792,280.444a.519.519,0,0,1,0-.753.533.533,0,1,1,0,.753Z",
    transform: "translate(-413.616 -279.535)",
    fill: "#4A4A4A"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706",
    transform: "translate(79.932)"
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13407",
    "data-name": "Path 13407",
    d: "M326.7,281.859a20.562,20.562,0,1,1-20.56-20.571A20.561,20.561,0,0,1,326.7,281.859Z",
    transform: "translate(-284.853 -260.561)",
    fill: "#F26A1B"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13408",
    "data-name": "Path 13408",
    d: "M326.026,281.909v-.959l1.244.208a21.161,21.161,0,0,0-1.419-7.15l-1.365.1-.368-.881,1.285-.3a21.425,21.425,0,0,0-4.064-5.988l-1.25.635-.679-.668,1.094-.8a21.108,21.108,0,0,0-6.185-4.026l-.926,1.112-.886-.353.713-1.187a21.1,21.1,0,0,0-6.7-1.254l-.458,1.369h-.958l.232-1.363a21.092,21.092,0,0,0-7.172,1.469l.109,1.436-.879.374-.325-1.35a21.261,21.261,0,0,0-5.974,4.119l.637,1.261-.67.676-.79-1.094a21.408,21.408,0,0,0-3.976,6.227l1.056.875-.352.9-1.119-.674a21.287,21.287,0,0,0-1.193,6.7l1.246.422v.955l-1.237-.212a21.139,21.139,0,0,0,1.506,7.14l1.269-.1.37.881-1.172.28a21.234,21.234,0,0,0,4.119,5.931l1.086-.558.682.675-.948.686a21.544,21.544,0,0,0,6.183,3.942l.772-.915.893.349-.591.973a21.341,21.341,0,0,0,6.657,1.212l.37-1.114h.957l-.189,1.1a21.038,21.038,0,0,0,7.11-1.464l-.089-1.184.886-.37.26,1.113a21.632,21.632,0,0,0,5.946-4.06l-.553-1.083.672-.683.686.948a21.417,21.417,0,0,0,4-6.143l-.976-.814.355-.89,1.042.629a21.1,21.1,0,0,0,1.264-6.657Z",
    transform: "translate(-284.693 -260.402)",
    fill: "#F26A1B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705",
    transform: "translate(2.5 2.496)"
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13409",
    "data-name": "Path 13409",
    d: "M325.318,282.234a18.789,18.789,0,1,1-18.789-18.788A18.784,18.784,0,0,1,325.318,282.234Z",
    transform: "translate(-287.74 -263.446)",
    fill: "#F26A1B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_701",
    "data-name": "Group 701",
    transform: "translate(0)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13410",
    "data-name": "Path 13410",
    d: "M323.892,278.125a23.406,23.406,0,0,1,1.012,8.058,18.792,18.792,0,1,0-37.164-3.949,18.613,18.613,0,0,0,1.114,6.389,4.182,4.182,0,0,1-.1-.434,17.766,17.766,0,0,1-.242-6.1,1.644,1.644,0,0,0,.024-.168,18.032,18.032,0,0,1,35.36-3.794Z",
    transform: "translate(-287.74 -263.446)",
    fill: "#636363",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13411",
    "data-name": "Path 13411",
    d: "M310.449,309.254c-.314.015-.622.02-.932.02C309.828,309.275,310.135,309.269,310.449,309.254Z",
    transform: "translate(-290.728 -271.692)",
    fill: "#1c1c1c"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13412",
    "data-name": "Path 13412",
    d: "M311.58,309.275c-.312,0-.619-.006-.926-.02C310.961,309.269,311.268,309.275,311.58,309.275Z",
    transform: "translate(-292.791 -271.692)",
    fill: "#1c1c1c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13413",
    "data-name": "Path 13413",
    d: "M320.159,283.488a12.181,12.181,0,1,1-12.183-12.178A12.181,12.181,0,0,1,320.159,283.488Z",
    transform: "translate(-289.187 -264.862)",
    fill: "#1c1c1c",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13414",
    "data-name": "Path 13414",
    d: "M318.93,284.03a10.605,10.605,0,1,1-10.607-10.6A10.612,10.612,0,0,1,318.93,284.03Z",
    transform: "translate(-289.534 -265.242)",
    fill: "#ededed",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13415",
    "data-name": "Path 13415",
    d: "M318.477,284.2a10.022,10.022,0,1,1-10.022-10.02A10.025,10.025,0,0,1,318.477,284.2Z",
    transform: "translate(-289.666 -265.379)",
    fill: "#6e460d"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13416",
    "data-name": "Path 13416",
    d: "M317.315,284.737a8.534,8.534,0,1,1-8.534-8.532A8.533,8.533,0,0,1,317.315,284.737Z",
    transform: "translate(-289.991 -265.743)",
    fill: "#4A4A4A"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13417",
    "data-name": "Path 13417",
    d: "M315.022,285.124a5.6,5.6,0,1,1-5.6-5.586A5.595,5.595,0,0,1,315.022,285.124Z",
    transform: "translate(-290.637 -266.343)",
    fill: "#4A4A4A"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_704",
    "data-name": "Group 704",
    transform: "translate(11.103 11.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_702",
    "data-name": "Group 702",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13418",
    "data-name": "Path 13418",
    d: "M311.054,277.517a.531.531,0,1,1-.53-.528A.531.531,0,0,1,311.054,277.517Z",
    transform: "translate(-302.824 -276.989)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13419",
    "data-name": "Path 13419",
    d: "M311.085,294.976a.528.528,0,0,1-.528.53.536.536,0,1,1,.528-.53Z",
    transform: "translate(-302.881 -280.129)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13420",
    "data-name": "Path 13420",
    d: "M301.807,286.8a.536.536,0,0,1,0-1.072.536.536,0,1,1,0,1.072Z",
    transform: "translate(-286.966 -278.561)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13421",
    "data-name": "Path 13421",
    d: "M319.254,286.767a.536.536,0,1,1,.54-.535A.538.538,0,0,1,319.254,286.767Z",
    transform: "translate(-318.723 -278.556)",
    fill: "#4A4A4A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_703",
    "data-name": "Group 703",
    transform: "translate(2.087 2.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13422",
    "data-name": "Path 13422",
    d: "M304.735,280.463a.535.535,0,1,1,0-.758A.536.536,0,0,1,304.735,280.463Z",
    transform: "translate(-293.691 -279.537)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13423",
    "data-name": "Path 13423",
    d: "M317.094,292.784a.533.533,0,1,1,0-.758A.536.536,0,0,1,317.094,292.784Z",
    transform: "translate(-316.184 -281.755)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13424",
    "data-name": "Path 13424",
    d: "M304,292.8a.532.532,0,1,1,.752-.753.53.53,0,0,1,0,.753A.522.522,0,0,1,304,292.8Z",
    transform: "translate(-293.73 -281.759)",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13425",
    "data-name": "Path 13425",
    d: "M316.32,280.444a.532.532,0,1,1,.753,0A.533.533,0,0,1,316.32,280.444Z",
    transform: "translate(-316.147 -279.535)",
    fill: "#4A4A4A"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_709",
    "data-name": "Group 709",
    transform: "translate(0 0.024)"
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13426",
    "data-name": "Path 13426",
    d: "M379.76,281.462a22.822,22.822,0,1,1,45.644,0,1.779,1.779,0,0,1-.014.238h2.371v-.238a25.177,25.177,0,1,0-50.355,0v.386h2.368C379.774,281.719,379.76,281.592,379.76,281.462Z",
    transform: "translate(-377.406 -256.276)",
    fill: "#F26A1B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13427",
    "data-name": "Path 13427",
    d: "M405.571,257.262a25.475,25.475,0,0,1,22.675,13.893A25.171,25.171,0,0,0,380.1,281.462v.386h.018A25.493,25.493,0,0,1,405.571,257.262Z",
    transform: "translate(-380.104 -256.276)",
    fill: "#949494",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_711",
    "data-name": "Group 711",
    transform: "translate(80.371)"
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13428",
    "data-name": "Path 13428",
    d: "M284.092,281.993c-.012-.189-.019-.375-.019-.563a22.814,22.814,0,0,1,44.019-8.421c.7-.391,1.395-.791,2.071-1.21a25.184,25.184,0,0,0-48.453,9.632c0,.189.013.375.013.563Z",
    transform: "translate(-281.71 -256.247)",
    fill: "#F26A1B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_710",
    "data-name": "Group 710",
    transform: "translate(0.098 0.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13429",
    "data-name": "Path 13429",
    d: "M307.437,257.262a25.47,25.47,0,0,1,22.673,13.893,25.174,25.174,0,0,0-48.147,10.307c0,.13.006.258.006.386h.013A25.5,25.5,0,0,1,307.437,257.262Z",
    transform: "translate(-281.963 -256.276)",
    fill: "#949494",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle2);
export default __webpack_public_path__ + "static/media/vehicle-2.81fa1fd44aed2db784de540392d18f92.svg";
export { ForwardRef as ReactComponent };